import { ServiceUtil } from "./services.util";
import parse from 'html-react-parser';
import { rejects } from "assert";
import { userService } from "./user.service";
import { LeadService } from "./newloan.service";
import { workflowConstants } from "../_constants";
import { DocumentApi } from "./document.service";

export const metadataService = {
    LOOKUP_INCOMEFREQUENCY: "incomeFrequency",
    LOOKUP_INCOMESOURCE: "incomeSource",
    LOOKUP_EMPLOYMENTSTATUS: "employmentStatus",
    LOOKUP_STATE: "state",
    fundDeliveryType: {
        Electronic: 1,
        InStore: 2
    },
    ENUM_RESIDENCE_TYPE: {
        OTHER: 0,
        OWN: 1,
        RENT: 2
    },
    checkPasswordComplexity,
    MobileNumberBeginsWithOneOrZero,
    ValidITIN,
    ValidSSN,
    getParsedBannerText,
    getLookup,
    getFieldNameLabel,
    getLabel,
    getMessage,
    getTitle,
    getFieldPlaceHolder,
    getLocations,
    getButton,
    getResourceValue,
    formatMoney,
    formatDateString,
    formatPhoneNumber,
    formatString,
    formatDuration,
    formatAddress,
    getMenu,
    getBranch,
    getLocalBranch,
    jsonFieldName,
    getLookupText,
    emailRegex,
    maskEmail,
    maskLastFourCharacters,
    maskExceptLastFourCharacters,
    checkRepeatingCharacter,
    newLoanStepperService,
    getCityStateByZip,
    validFileTypeList,
    getLookupAsHashMap,
    isNullOrEmpty,
};

function validFileTypeList() {
    return ["image/png",
        "image/jpg",
        "image/jpeg",
        "application/pdf"
    ];
}

export function newLoanStepperService(stepType) {
    if (stepType === workflowConstants.NEW_LOAN_WORKFLOW) {
        return [
            { text: getLabel("GetStarted"), value: 0 },
            { text: getLabel("Information"), value: 1 },
            { text: getLabel("Finances"), value: 2 },
            { text: getLabel("Funding"), value: 3 },
            { text: getLabel("Submit"), value: 4 }
        ]
    }
    if (stepType === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW) {
        return [
            { text: getLabel("LoanAmount"), value: 0 },
            { text: getLabel("Submit"), value: 1 }
        ]
    }
    if (stepType === workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) {
        return [
            { text: getLabel("Welcome"), value: 0 },
            { text: getLabel("Submit"), value: 2 },
        ]
    }
    if (stepType === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW) {
        return [
            { text: getLabel("RefinanceIncrease"), value: 0 },
            { text: getLabel("Information"), value: 1 },
            { text: getLabel("Finances"), value: 2 },
            { text: getLabel("FundingOptions"), value: 3 },
            { text: getLabel("Submit"), value: 4 },
            // { text: getLabel("Contract"), value: 5 },
        ]
    }
    if (stepType === workflowConstants.APPLICATION_RECEIVED_WORKFLOW) {
        return [
            { text: getLabel("Signup"), value: 0 },
            { text: getLabel("ConfirmEmail"), value: 1 },
        ]
    }
    if (stepType === workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW) {
        return [
            { text: getLabel("ConfirmAccount"), value: 0 },
            { text: getLabel("SetPassword"), value: 1 },
            { text: getLabel("ConfirmEmail"), value: 2 },
        ]
    }
    if (stepType === workflowConstants.GUEST_PAYMENT_REGISTRATION) {
        return [
            { text: getLabel("SetPassword"), value: 0 },
            { text: getLabel("ConfirmEmail"), value: 1 },
        ]
    }
    if (stepType === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) {
        return [
            { text: getLabel("RefinanceIncrease"), value: 0 },
            { text: getLabel("Submit"), value: 1 },
        ]
    }
}

function checkPasswordComplexity(password) {
    if (password.length < 8) {
        return false;
    }

    const upperCaseRegEx = new RegExp("^(?=.*[A-Z])");
    if (!upperCaseRegEx.test(password)) {
        return false;
    }

    const lowerCaseRegEx = new RegExp("^(?=.*[a-z])");
    if (!lowerCaseRegEx.test(password)) {
        return false;
    }

    const numericCaseRegEx = new RegExp("(?=.*[0-9])");
    if (!numericCaseRegEx.test(password)) {
        return false;
    }

    const specialcharsCaseRegEx = new RegExp(
        "(?=.*[!@#$%^&*()~`+={[}}]|'\"<,.>-_;:])"
    );
    //works new RegExp(("(?=.*[!@#\$%\^&\*\(\)~`+=\{\[\}}]\|\'\"<,.>-_;:])"));
    if (!specialcharsCaseRegEx.test(password)) {
        return false;
    }

    return true;
}

function MobileNumberBeginsWithOneOrZero(mobilePhone) {
    const phoneBeginsWithRegEx = new RegExp("^[0-1]{1}");
    var isPhoneNumberBeginsWithZeroOrOne = phoneBeginsWithRegEx.test(mobilePhone);

    return isPhoneNumberBeginsWithZeroOrOne;
    //if (isPhoneNumberBeginsWithZeroOrOne) {
    //    mobilePhoneError = true;
    //}
    //else {
    //    mobilePhoneError = false;
    //}
}

function ValidITIN(itin) {

    const itinRegex = /^(9\d{2})([ \-]?)(5\d|6[0-5]|7\d|8[0-8]|9[0-2]|9[4-9])([ \-]?)(\d{4})$/g;

    var isValidItin = itinRegex.test(itin);

    return isValidItin;
}

function ValidSSN(ssn) {
    const ssnRegex = /^(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
    var isValidSSN = ssnRegex.test(ssn);
    return isValidSSN;
}

function checkRepeatingCharacter(str) {
    // repeating character in a string regex
    const checkForRepeatRegex = /^([a-z])\1+$/;
    if (checkForRepeatRegex.test(str)) {
        return true;
    }

    return false;
}

function emailRegex(email) {
    const emailRegexPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegexPattern.test(email)) {
        return true
    } else {
        return false
    }
}

function maskEmail(email) {
    const leftSide = email.substring(0, email.indexOf('@'));
    const rightSide = email.substring(email.indexOf('@'));
    const value = leftSide.replace(leftSide.substring(1, leftSide.length - 1), "*****");
    return value + rightSide;
}

function maskLastFourCharacters(valueToMask) {
    return valueToMask.replace(/\d(?=\d{4})/g, "#");
}

function maskExceptLastFourCharacters(valueToMask) {
    return "XXXX" + valueToMask.slice(-4)
}

function getParsedBannerText(bannerText) {
    return parse(bannerText);
}

function jsonFieldName(fieldName) {
    return fieldName.substr(0, 1).toLowerCase() + fieldName.substr(1);
}

function getLookupText(lookupName, value) {
    const lookupArray = getLookup(lookupName);
    let val = lookupArray.find((e) => e.value.toString() === value.toString());
    if (val) {
        return val.text;
    }
    return lookupName + "=>" + value;
}

function getLocalBranch() {
    const branchId = ServiceUtil.getLocalBranchId();
    if (branchId) {
        //get the branch.
        return getBranch(branchId);
    }
    return Promise.reject(null);
}

function getLocations(zipCode, userState, userCity) {
    return ServiceUtil.executeServiceCall(
        "MetadataAPI",
        "Metadata/GetOfficesByZip?zip=" + zipCode + "&userState=" + userState + "&userCity=" + userCity,
        ServiceUtil.getRequest()
    );
}

function getBranch(sunLoanBranchId) {
    return ServiceUtil.executeServiceCall(
        "MetadataAPI",
        "Metadata/GetOfficeById?SunLoanBranchId=" + sunLoanBranchId,
        ServiceUtil.getRequest()
    );
}


function getCityStateByZip(zip) {
    return ServiceUtil.executeServiceCall(
        "MetadataAPI",
        "Metadata/GetCityStateByZip?zip=" + zip,
        ServiceUtil.getRequest()
    );
}

function getMenu(menuItemName) {
    if (getResourceValue("Menu", menuItemName)) {
        return getResourceValue("Menu", menuItemName);
    }
    return "~ Menu :: " + menuItemName + " ~";
}

function getResourceValue(resourceName, valueName) {
    //get user language.
    var userLang = userService.getUserLanguage();
    if (userLang.toLowerCase() === "es") {
        const resourceGroup = resources[resourceName + ".es"];
        if (!resourceGroup) {
            console.log("Resource Group Not Found : " + resourceGroup);
        }
        if (resourceGroup && resourceGroup[valueName]) {
            return resourceGroup[valueName];
        } else {
            console.log(
                "Language Resource Not Found: " + resourceName + "::" + valueName
            );
        }
    }
    return resources[resourceName][valueName];
}

function getFieldNameLabel(fieldName) {
    let val = getResourceValue("Labels", fieldName);
    if (val) {
        return val;
    }
    val = getResourceValue("FieldNames", fieldName);
    if (val) {
        return val;
    }
    //This ensures that there is ALWAYS a return value.
    return "~ FieldNameLabel::" + fieldName + "~";
}

function getFieldPlaceHolder(fieldName) {
    if (getResourceValue("PlaceHolder", fieldName)) {
        return getResourceValue("PlaceHolder", fieldName);
    } else if (getResourceValue("Labels", fieldName)) {
        return getResourceValue("Labels", fieldName);
    } else if (getResourceValue("FieldNames", fieldName)) {
        return getResourceValue("FieldNames", fieldName);
    }

    return "~ FieldPlaceHolder::" + fieldName + "~";
}

function getLabel(labelName) {
    if (getResourceValue("Labels", labelName)) {
        return getResourceValue("Labels", labelName);
    }

    //This ensures that there is ALWAYS a return value.
    return "~ Label::" + labelName + "~";
}

function getMessage(messageName) {
    if (getResourceValue("Messages", messageName)) {
        var format = getResourceValue("Messages", messageName);
        var args = Array.prototype.slice.call(arguments, 1);
        return formatString(format, args);
    }
    return "~ Message::" + messageName + "~";
}

function formatString(format, args) {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] !== "undefined" ? args[number] : match;
    });
}

function formatAddress(address1, address2, city, state, postalCode) {
    var formattedAddress = "";

    if (address1) {
        formattedAddress += address1;
    }

    if (address2) {
        formattedAddress += " " + address2;
    }

    if (city) {
        formattedAddress += ", " + city;
    }

    if (state) {
        formattedAddress += ", " + state;
    }

    if (postalCode) {
        formattedAddress += " " + postalCode;
    }

    return formattedAddress;
}

function getTitle(titleName) {
    if (getResourceValue("PageTitles", titleName)) {
        return getResourceValue("PageTitles", titleName);
    }

    //This ensures that there is ALWAYS a return value.
    return "[" + titleName + "]";
}

function getButton(buttonName) {
    if (getResourceValue("Buttons", buttonName)) {
        return getResourceValue("Buttons", buttonName);
    }

    //This ensures that there is ALWAYS a return value.
    return "[Button::" + buttonName + "]";
}
function getLookup(lookupName) {
    if (lookupName === "milesFromBranch") {
        return [
            { value: 5, text: '5' },
            { value: 10, text: '10' },
            { value: 25, text: '25' },
            { value: 50, text: '50' }
        ]
    }

    if (lookupName === "employmentStatus") {
        return [
            { value: 1, text: getResourceValue("Labels", "IncomeSource_FullTime") },
            { value: 2, text: getResourceValue("Labels", "IncomeSource_PartTime") },
            { value: 3, text: getResourceValue("Labels", "IncomeSource_SelfEmployed") },
            { value: 4, text: getResourceValue("Labels", "IncomeSource_NotEmployed") }
        ];
    }

    if (lookupName === "incomeFrequency") {
        return [
            { value: "1", text: getResourceValue("Labels", "IncomeFreq_Weekly") },
            { value: "2", text: getResourceValue("Labels", "IncomeFreq_BiWeekly") },
            { value: "3", text: getResourceValue("Labels", "IncomeFreq_SemiMonth") },
            { value: "4", text: getResourceValue("Labels", "IncomeFreq_Monthly") },
            { value: "5", text: getResourceValue("Labels", "IncomeFreq_Annual") },
            { value: "6", text: getResourceValue("Labels", "IncomeFreq_SemiAnnual") },
        ];
    }
    if (lookupName === "otherIncomeSource") {
        return [
            { value: "4", text: getResourceValue("Labels", "IncomeSource_ChildSupport") },
            { value: "5", text: getResourceValue("Labels", "IncomeSource_Alimony") },
            { value: "6", text: getResourceValue("Labels", "IncomeSource_SocialSecurity") },
            { value: "7", text: getResourceValue("Labels", "IncomeSource_Other") },
        ];
    }
    if (lookupName === "incomeSource") {
        return [
            { value: 1, text: getResourceValue("Labels", "IncomeSource_FullTime") },
            { value: 2, text: getResourceValue("Labels", "IncomeSource_PartTime") },
            {
                value: 3,
                text: getResourceValue("Labels", "IncomeSource_SelfEmployed"),
            },
            {
                value: 4,
                text: getResourceValue("Labels", "IncomeSource_ChildSupport"),
            },
            { value: 5, text: getResourceValue("Labels", "IncomeSource_Alimony") },
            {
                value: 6,
                text: getResourceValue("Labels", "IncomeSource_SocialSecurity"),
            },
        ];
    }
    if (lookupName === "leadStatus") {
        return [
            {
                value: LeadService.LEAD_APPLIED,
                text: getResourceValue("Labels", "Lead_Applied"),
            },
            {
                value: LeadService.LEAD_APPROVED,
                text: getResourceValue("Labels", "Lead_Approved"),
            },
            {
                value: LeadService.LEAD_DECLINED,
                text: getResourceValue("Labels", "Lead_Declined"),
            },
            {
                value: LeadService.LEAD_NOCONTACT,
                text: getResourceValue("Labels", "Lead_NoContact"),
            },
            {
                value: LeadService.LEAD_WITHDRAWN,
                text: getResourceValue("Labels", "Lead_Withdrawn"),
            },
        ];
    }

    if (lookupName === "documentClassifications") {
        return [
            {
                value: 0,
                text: "Unknown",
            },
            {
                value: 1,
                text: "Employment",
            },
            {
                value: 2,
                text: "Residence",
            },
            {
                value: 3,
                text: "IdentityFront",
            },
            {
                value: 4,
                text: "IdentityBack",
            },
            {
                value: 5,
                text: "Income",
            },
        ];
    }

    if (lookupName === "state") {
        return [
            { value: "AL", text: "Alabama" },
            { value: "AK", text: "Alaska" },
            { value: "AZ", text: "Arizona" },
            { value: "AR", text: "Arkansas" },
            { value: "CA", text: "California" },
            { value: "CO", text: "Colorado" },
            { value: "CT", text: "Connecticut" },
            { value: "DE", text: "Delaware" },
            { value: "DC", text: "District of Columbia" },
            { value: "FL", text: "Florida" },
            { value: "GA", text: "Georgia" },
            { value: "HI", text: "Hawaii" },
            { value: "ID", text: "Idaho" },
            { value: "IL", text: "Illinois" },
            { value: "IN", text: "Indiana" },
            { value: "IA", text: "Iowa" },
            { value: "KS", text: "Kansas" },
            { value: "KY", text: "Kentucky" },
            { value: "LA", text: "Louisiana" },
            { value: "ME", text: "Maine" },
            { value: "MD", text: "Maryland" },
            { value: "MA", text: "Massachusetts" },
            { value: "MI", text: "Michigan" },
            { value: "MN", text: "Minnesota" },
            { value: "MS", text: "Mississippi" },
            { value: "MO", text: "Missouri" },
            { value: "MT", text: "Montana" },
            { value: "NE", text: "Nebraska" },
            { value: "NV", text: "Nevada" },
            { value: "NH", text: "New Hampshire" },
            { value: "NJ", text: "New Jersey" },
            { value: "NM", text: "New Mexico" },
            { value: "NY", text: "New York" },
            { value: "NC", text: "North Carolina" },
            { value: "ND", text: "North Dakota" },
            { value: "OH", text: "Ohio" },
            { value: "OK", text: "Oklahoma" },
            { value: "OR", text: "Oregon" },
            { value: "PA", text: "Pennsylvania" },
            { value: "RI", text: "Rhode Island" },
            { value: "SC", text: "South Carolina" },
            { value: "SD", text: "South Dakota" },
            { value: "TN", text: "Tennessee" },
            { value: "TX", text: "Texas" },
            { value: "UT", text: "Utah" },
            { value: "VT", text: "Vermont" },
            { value: "VA", text: "Virginia" },
            { value: "WA", text: "Washington" },
            { value: "WV", text: "West Virginia" },
            { value: "WI", text: "Wisconsin" },
            { value: "WY", text: "Wyoming" },
        ];
    }
    if (lookupName === "language") {
        return [
            {
                value: "en",
                text: getResourceValue("Labels", "LanguageEnglish"),
            },
            {
                value: "es",
                text: getResourceValue("Labels", "LanguageSpanish"),
            },
        ];
    }
    if (lookupName === "idType") {
        return [
            {
                value: "SSN",
                text: getFieldNameLabel("SocialSecurityNumber"),
            },
            {
                value: "MC",
                text: getFieldNameLabel("MatrículaConsular"),
            },
        ];
    }
    if (lookupName === "documentStatus") {
        return [
            {
                value: DocumentApi.DOCUMENT_STATUS_NEW,
                text: getResourceValue("Labels", "DocumentStatus_New"),
            },
            {
                value: DocumentApi.DOCUMENT_STATUS_PENDING,
                text: getResourceValue("Labels", "DocumentStatus_Pending"),
            },
            {
                value: DocumentApi.DOCUMENT_STATUS_UNDERREVIEW,
                text: getResourceValue("Labels", "DocumentStatus_UnderReview"),
            },
            {
                value: DocumentApi.DOCUMENT_STATUS_REJECTED,
                text: getResourceValue("Labels", "DocumentStatus_Rejected"),
            },
            {
                value: DocumentApi.DOCUMENT_STATUS_ACCEPTED,
                text: getResourceValue("Labels", "DocumentStatus_Approved"),
            },
            {
                value: DocumentApi.DOCUMENT_STATUS_NO_APPLICATION_FOUND,
                text: getResourceValue("Labels", "DocumentStatus_NoApplicationFound"),
            },
        ]
    }
    if (lookupName === "residenceType") {
        return [
            { value: 2, text: getResourceValue("Labels", "ResidenceType_Rent") },
            { value: 1, text: getResourceValue("Labels", "ResidenceType_Own") },
            { value: 0, text: getResourceValue("Labels", "ResidenceType_Other") },
        ];
    }
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return null;
}

function formatMoney(n) {
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    return formatter.format(n);
}

function formatDateString(d) {
    if (d) {
        const dtm = new Date(d);
        const month = dtm.getUTCMonth() + 1;
        const day = dtm.getUTCDate();
        const year = dtm.getUTCFullYear();
        return (
            (month < 10 ? "0" + month : month) +
            "/" +
            (day < 10 ? "0" + day : day) +
            "/" +
            year
        );
    }
    return "";
}

function formatDuration(years, months) {
    let parts = [];

    if (years > 0) {
        parts.push(`${years} ${years > 1 ? getResourceValue("Labels", "Years") : getResourceValue("Labels", "Year")}`);
    }

    if (months > 0) {
        parts.push(`${months} ${months > 1 ? getResourceValue("Labels", "Months") : getResourceValue("Labels", "Month")}`);
    }
    if (months === 0 && years === 0) {
        parts.push(`${years} ${getResourceValue("Labels", "Year")}`);
        parts.push(`${months} ${getResourceValue("Labels", "Month")}`);
    }
    return parts.join(", ");
}

function getLookupAsHashMap(lookupName) {
    const lookup = getLookup(lookupName) || [];
    const map = {}
    lookup.forEach((item) => {
        map[item.value] = item.text;
    });
    return Object.keys(map).length > 0 ? map : null;
}

function isNullOrEmpty(value) {
    return value === null || value === undefined
        || String(value + "").trim() === ""
        || JSON.stringify(value) === "{}"
        || (Array.isArray(value) && [...value].length === 0);
}

var resources = {
    "Buttons.es": {
        AccountHistory: "Historial de cuentas",
        AddAnotherReferral: "Añadir otra persona",
        Add: "Añadir",
        Agree: "Aceptar",
        ApplyForANewLoan: "Solicita un Nuevo Préstamo",
        Back: "Regresar",
        Cancel: "Cancelar",
        ChangePassword: "Cambiar contraseña",
        ConfirmCode: "Confirmar Código",
        Continue: "Continue",
        ClickToEnterCode: "¡Haga clic para ingresar el código! >",
        ClickHere: "Haga clic aquí",
        ClickToEdit: "Haga clic para Editar",
        Edit: "Editar",
        ContactCustomerService: "Contactar servicio al cliente",
        CreateAnAccount: "Crear una cuenta",
        DeleteSavedCards: "Eliminar tarjetas guardadas",
        Disagree: "Discrepar",
        Done: "Completado",
        EditProfile: "Editar perfil",
        English: "EN",
        Espanol: "ES",
        Find_Location: "Encuentra una sucursal de préstamos",
        ForgotPassword: "Olvidé la contraseña",
        GetStarted: "Empezar",
        MakeAnotherSelection: "Selecciona Otra Opcion",
        MakePayment: "Haz un pago",
        Next: "Continuar",
        NewLoan: "Nuevo Préstamos",
        NoThanks: "No, gracias",
        OK: "OK",
        PreviousResults: "Resultados anteriores",
        PreApprovalCode: "Código de Aprobación Previa",
        Processing: "Procesando...",
        Refinance: "Refinanciar",
        RefinanceDispatch: "Refinanciamiento",
        Remove: "Eliminar",
        RemoveSavedBank: "Eliminar el método de pago guardado",
        RemoveSavedCard: "Eliminar el método de pago guardado",
        RemoveSavedPaymentMethod: "Eliminar el método de pago guardado",
        Req_New: "Solicitar un préstamo nuevo",
        RequestLoan: "Solicitar este préstamo",
        Save: "Guardar",
        SecurityOptions: "Opciones de seguridad",
        SeeMoreLocations: "Ver más ubicaciones",
        SendCode: "Enviar código",
        SignIn: "Acceso",
        SignUp: "Regístrate hoy",
        Submit: "Enviar",
        SubmitApp: "Presentar mi solicitud",
        TryAgain: "Vuelve a intentarlo",
        View: "Ver",
        Yes: "Sí",
        No: "No",
    },
    Buttons: {
        AccountHistory: "Account History",
        AddAnotherReferral: "Add Another Person",
        Add: "Add",
        Agree: "Agree",
        ApplyForANewLoan: "Apply for a New Loan",
        Back: "Back",
        Cancel: "Cancel",
        ChangePassword: "Change Password",
        ClickToEnterCode: "Click to Enter Code! >",
        ClickHere: "Click here",
        ClickToEdit: "Click to Edit",
        ConfirmCode: "Confirm Code",
        Edit: "Edit",
        ContactCustomerService: "Contact Customer Service",
        Continue: "Continue",
        Close: "Close",
        CreateAnAccount: "Create an account",
        Disagree: "Disagree",
        Done: "Done",
        EditProfile: "Edit Profile",
        English: "EN",
        Espanol: "ES",
        Find_Location: "Find a Branch",
        ForgotPassword: "Forgot password",
        GetStarted: "Get Started",
        MakeAnotherSelection: "Make Another Selection",
        MakePayment: "Make a Payment",
        Next: "Next",
        NewLoan: "New Loan",
        NoThanks: "No Thanks",
        OK: "OK",
        PreviousResults: "Previous Results",
        PreApprovalCode: "Pre-Approval Code",
        Processing: "Processing...",
        Refinance: "Refinance",
        RefinanceDispatch: "Increase or Refinance",
        Remove: "Remove",
        RemoveSavedBank: "Remove Saved Bank",
        RemoveSavedCard: "Remove Saved Card",
        RemoveSavedPaymentMethod: "Remove Saved Payment Method",
        Req_New: "Apply for New Loan",
        RequestLoan: "Request This Loan",
        Save: "Save",
        SecurityOptions: "Security Options",
        SeeMoreLocations: "See More Locations",
        SendCode: "Send Code",
        SignIn: "Sign in",
        SignUp: "Sign up today",
        Submit: "Submit",
        SubmitApp: "Submit my application",
        TryAgain: "Try Again",
        View: "View",
        Yes: "Yes",
        No: "No",
    },
    "FieldNames.es": {
        AccountNumber: "Número de cuenta",
        Active: "Activo",
        Address: "Dirección",
        Address1: "Línea de dirección 1",
        Address2: "Línea de dirección 2",
        Amount: "Cantidad",
        AuthCode: "Código de autenticación",
        Balance: "Saldo",
        BalanceDue: "Saldo a pagar",
        BankAccountType: "Información Bancaria",
        BankName: "Nombre del banco",
        BankMonths: "Meses con banco",
        BankruptcyFlag: "Bandera de bancarrota",
        BodyTemplate: "Plantilla de cuerpo",
        BranchId: "Oficina de Sun Loan",
        CardBrand: "Marca de tarjeta",
        CardDescription: "Descripción de la tarjeta",
        CardExpiration: "Vencimiento",
        CardLastFour: "Los últimos 4 dígitos en la tarjeta",
        CardName: "Nombre de la tarjeta",
        City: "Ciudad",
        ClientId: "Id de cliente",
        CodeParts: "Código de piezas",
        ConfirmAccountNumber: "Confirmar número de cuenta",
        ConfirmPassword: "Confirmar contraseña",
        ConfirmRoutingNumber: "Confirmar número de ruta",
        ContentId: "Content Id",
        County: "Condado",
        Data: "Datos",
        DateOfBirth: "Fecha de nacimiento",
        DateTimeOffset: "DateTimeOffset",
        DeliveryMethod: "Método de entrega",
        Description: "Descripción",
        DescribeEmploymentStatus: "De las siguentes opciones ¿Cuál describe mejor esta fuente de ingreso?",
        DeviceId: "Idde del dispositivo",
        DriversLicenseNumber: "Licencia para conducir",
        DriversLicenseState: "Estado de la licencia de conducir",
        DOB: "Fecha de nacimiento",
        Earnings: "¿Cuánto gana por período de pago?",
        Email: "Correo electrónico",
        EmailAddress: "Dirección de correo electrónico",
        EnterId: "Por favor proporcione el número",
        EntryId: "Identificador de entrada",
        Errors: "Errores",
        FirstName: "Nombre",
        Global: "Global",
        HttpResponseCode: "Código de respuesta Http",
        ImageUrl: "Url de imagen",
        IncomePerPeriod: "Ingresos netos por período de pago",
        IncomeSource: "Fuente de Ingresos Primarios",
        IncomeSourceShort: "Fuente de Ingresos",
        Index: "Índice",
        IndividualTaxIdentificationNumberITIN: "Número de Identificación Personal del Contribuyente (ITIN)",
        IndividualTaxIdentificationNumber: "Número de Identificación Personal del Contribuyente",
        IpAddress: "Dirección IP",
        InterestDue: "Interés a pagar",
        IsAdmin: "¿Es Admin",
        IssueDate: "Fecha de emisión",
        IssuedUserId: "Id. de usuario emitido",
        IssueReason: "Motivo del problema",
        Language: "Idioma",
        LastModified: "Ultima modificación",
        LastName: "Apellido(s)",
        LeadId: "ID de la referencia",
        LeadType: "tipo de referencia",
        LinkUrl: "Url de enlace",
        LoanPayments: "Pagos de préstamos",
        LoanType: "Tipo de préstamo",
        MarketingTarget: "Objetivo de marketing",
        MatrículaConsular: "Matrícula Consular",
        Message: "Mensaje",
        MessageType: "Tipo de mensaje",
        Miles: "Milla",
        MobileNumber: "Número de celular",
        AlternateMobileNumber: "Número alterno de celular",
        MobileOptIn: "Opt In móvil",
        MobilePhone: "Número de teléfono celular",
        AlternateMobilePhone: "Número alterno de teléfono celular",
        MonthlyOtherIncome: "Cantidad de Otro Ingreso Mensual",
        MonthlyResidencePayment: "Pago de residencia mensual",
        MonthlyMortgagePayment: "Pago mensual",
        MonthlyRentalPayment: "Renta mensual",
        MonthlyResidenceExpense: "Gasto Residencial Mensual",
        MultiFactorReason: "Razón multifactor",
        Name: "Nombre",
        NationalIdNumber: "Matrícula Consular",
        NetIncome: "Ingresos netos",
        NextPaymentAmount: "Próximo pago",
        OfficeId: "Id de oficina",
        OfficeName: "Nombre de la oficina",
        OldPassword: "Contraseña anterior",
        OriginalLoanAmount: "Importe original del préstamo",
        OtherAmount: "Otra cantidad",
        Parameters: "Parámetros",
        Password: "Contraseña",
        Payoff: "Saldar",
        PayoffAmount: "Saldo a pagar",
        PayoffGoodUntil: "Válido hasta",
        PayFrequency: "Frecuencia de pago",
        PaymentAmount: "Cantidad del pago",
        PaymentDate: "Fecha de pago",
        PaymentDueDate: "Fecha de vencimiento",
        PNRef: "PN Ref",
        PostalCode: "Código postal",
        PreApprovalCode: "Código de Aprobación Previa",
        PrimaryIncome: "Fuente de Ingresos Primarios",
        Processed: "Procesado",
        ProfileType: "Tipo de perfil",
        Reason: "Razón",
        ReEnterSocialSecurityNumber: "Vuelva a ingresar el número de seguro social",
        ReEnterIndividualTaxIdentificationNumber: "Vuelva a introducir el número de identificación fiscal individual",
        ReferralName: "Nombre",
        RequestedAmount: "Cantidad solicitada",
        RequestType: "Tipo de solicitud",
        RentOrOwn: "Renta o es Dueño",
        ResultCode: "Código de resultados",
        ResultMsg: "Resultado Msg",
        RequestDate: "Fecha de solicitud",
        ResidenceType: "Tipo de Residencia",
        RoutingNumber: "Número de ruta",
        Scheduled: "Programado",
        SelectedLanguage: "Idioma seleccionado",
        SocialSecurityNumber: "Número de Seguro Social",
        SocialSecurityNumberSSN: "Número de Seguro Social (SSN)",
        Source: "Fuente",
        State: "Estado",
        Status: "Estatus",
        StoredPaymentType: "Tipo de pago almacenado",
        StoredPmtId: "StoredPmtId",
        Street1: "Calle 1",
        Street2: "Calle 2",
        SubjectTemplate: "Plantilla de asunto",
        Succeeded: "Tuvo éxito",
        SuggestedPayment: "Pago sugerido",
        Payment: "Pago",
        SunLoanBranchId: "ID de la oficina de Sun Loan",
        CurrentLoanId: "Id. de Préstamo Sun",
        UserId: "UserId de Sun Loan",
        TargetAddress: "Dirección de destino",
        TargetId: "Id de objetivo",
        TextContent: "Contenido de texto",
        TimeEmployed: "Tiempo Empleado",
        TimeInResidence: "Tiempo en su Residencia",
        Timestamp: "Timestamp",
        TokenHash: "Token Hash",
        TokenId: "Id de token",
        UpToDate: "A hoy",
        UpToDateAmount: "Saldo actual",
        Used: "Utilizado",
        UserAddressSource: "Origen",
        UserHash: "UserHash",
        UserLoan: "Préstamo de usuario",
        UserLoans: "Préstamos para usuarios",
        Username: "nombre de usuario",
        ValidationErrors: "Errores de validación",
        ValidFrom: "Válido desde",
        ValidTo: "Válido para",
        Veteran: "Veterano",
        Zip: "Código postal",
        ZipCode: "Código postal",
    },
    FieldNames: {
        AccountNumber: "Account Number",
        Active: "Active",
        Address: "Address",
        Address1: "Address Line 1",
        Address2: "Address Line 2",
        Amount: "Amount",
        AuthCode: "Auth Code",
        Balance: "Balance",
        BalanceDue: "Balance Due",
        BankAccountType: "Bank Account Type",
        BankName: "Bank Name",
        BankMonths: "Months with bank",
        BankruptcyFlag: "Bankruptcy Flag",
        BodyTemplate: "Body Template",
        BranchId: "Sun Loan Branch",
        CardBrand: "Card Brand",
        CardDescription: "Card Description",
        CardExpiration: "Expiration",
        CardLastFour: "Last 4 Digits on Card",
        CardName: "Card Name",
        City: "City",
        ClientId: "Client Id",
        CodeParts: "Code Parts",
        ConfirmAccountNumber: "Confirm Account Number",
        ConfirmPassword: "Confirm Password",
        ConfirmRoutingNumber: "Confirm Routing Number",
        ContentId: "Content Id",
        County: "County",
        Data: "Data",
        DateOfBirth: "Date Of Birth",
        DateTimeOffset: "DateTimeOffset",
        DeliveryMethod: "Delivery Method",
        Description: "Description",
        DescribeEmploymentStatus: "Which of the following best describes this source of income",
        DeviceId: "Device Id",
        DriversLicenseNumber: "Drivers license number",
        DriversLicenseState: "Drivers license state",
        DOB: "Date of Birth  (MM/DD/YYYY)",
        Earnings: "How much do you make per pay period?",
        Email: "Email",
        EmailAddress: "Email Address",
        EnterId: "Please Enter the Number",
        EntryId: "Entry Id",
        Errors: "Errors",
        FieldName: "Field Name",
        FirstName: "First Name",
        FundDelivery: "Fund Delivery",
        Global: "Global",
        HttpResponseCode: "Http Response Code",
        ImageUrl: "Image Url",
        IncomePerPeriod: "Income Per Period",
        IncomeSource: "Primary Income Source",
        IncomeSourceShort: "Income Source",
        Index: "Index",
        IndividualTaxIdentificationNumberITIN: "Individual Tax Identification Number (ITIN)",
        IndividualTaxIdentificationNumber: "Individual Tax Identification Number",
        InterestDue: "Interest Due",
        IpAddress: "Ip Address",
        IsAdmin: "Is Admin",
        IssueDate: "Issue Date",
        IssuedUserId: "Issued User Id",
        IssueReason: "Issue Reason",
        Language: "Language",
        LastModified: "Last Modified",
        LastName: "Last Name(s)",
        LeadId: "Lead Id",
        LeadType: "Lead Type",
        LinkUrl: "Link Url",
        LoanPayments: "Loan Payments",
        LoanType: "Loan Type",
        MarketingTarget: "Marketing Target",
        MatrículaConsular: "Matrícula Consular",
        Message: "Message",
        MessageType: "Message Type",
        Miles: "Miles",
        MobileNumber: "Mobile Number",
        AlternateMobileNumber: "Alternate Mobile Number",
        MobileOptIn: "Mobile Opt In",
        MobilePhone: "Mobile Phone Number",
        AlternateMobilePhone: "Alternate Mobile Phone Number",
        MonthlyOtherIncome: "Monthly Other Income",
        MonthlyResidencePayment: "Monthly Residence Payment",
        MonthlyMortgagePayment: "Monthly Mortgage",
        MonthlyRentalPayment: "Monthly Rent",
        MonthlyResidenceExpense: "Monthly Residence Expense",
        MultiFactorReason: "Multi Factor Reason",
        Name: "Name",
        NationalIdNumber: "Matricula Consular",
        NetIncome: "Net Income",
        NextPaymentAmount: "Next Payment",
        OfficeId: "Office Id",
        OfficeName: "Office Name",
        OldPassword: "Old Password",
        OriginalLoanAmount: "Original Loan Amount",
        OtherAmount: "Other Amount",
        Parameters: "Parameters",
        Password: "Password",
        Payoff: "Payoff",
        PayoffAmount: "Payoff Amount",
        PayoffGoodUntil: "Good until",
        PayFrequency: "Pay Frequency",
        PaymentAmount: "Payment Amount",
        PaymentDate: "Payment Date",
        PaymentDueDate: "Due Date",
        PNRef: "PN Ref",
        PostalCode: "ZIP Code",
        PreApprovalCode: "Pre-Approval Code",
        PrimaryIncome: "Primary Income Source",
        Processed: "Processed",
        ProfileType: "Profile Type",
        Reason: "Reason",
        ReEnterSocialSecurityNumber: "Re-enter Social Security Number",
        ReEnterIndividualTaxIdentificationNumber: "Re-enter Individual Tax Identification Number",
        ReferralName: "Name",
        RequestDate: "Request Date",
        RequestedAmount: "Requested Amount",
        RequestType: "Request Type",
        RentOrOwn: "Rent or Own",
        ResultCode: "Result Code",
        ResultMsg: "Result Msg",
        ResidenceType: "Residence Type",
        RoutingNumber: "Routing Number",
        Scheduled: "Scheduled",
        SelectedLanguage: "Selected Language",
        SocialSecurityNumber: "Social Security Number",
        SocialSecurityNumberSSN: "Social Security Number (SSN)",
        Source: "Source",
        State: "State",
        Status: "Status",
        StoredPaymentType: "Stored Payment Type",
        StoredPmtId: "StoredPmtId",
        Street1: "Street 1",
        Street2: "Street 2",
        SubjectTemplate: "Subject Template",
        Succeeded: "Succeeded",
        SuggestedPayment: "Suggested Payment",
        Payment: "Payment",
        SunLoanBranchId: "Sun Loan Branch Id",
        CurrentLoanId: "Sun Loan Loan Id",
        UserId: "Sun Loan UserId",
        TargetAddress: "Target Address",
        TargetId: "Target Id",
        TextContent: "Text Content",
        TimeEmployed: "Time Employed",
        TimeInResidence: "Time in Residence",
        Timestamp: "Timestamp",
        TokenHash: "Token Hash",
        TokenId: "Token Id",
        Used: "Used",
        UpToDate: "UpToDate",
        UpToDateAmount: "Up To Date Amount",
        UserAddressSource: "Source",
        UserHash: "UserHash",
        UserLoan: "User Loan",
        UserLoans: "User Loans",
        Username: "Username",
        ValidationErrors: "Validation Errors",
        ValidFrom: "Valid From",
        ValidTo: "Valid To",
        Veteran: "Veteran",
        Zip: "Zip Code",
        ZipCode: "Zip Code",
    },
    "Labels.es": {
        AccountActivityAmount: "Cantidad pagada",
        AccountActivityBalance: "Saldo",
        AccountActivityDate: "Fecha de pago",
        AccountActivityConvenienceFee: "Cargo por servicio",
        AccountActivityToBalance: "Al saldo",
        AccountActivityToOther: "A otros",
        AccountInactive: "Cuent Inactiva",
        AccountHistoryTitle:
            "El monto del saldo del préstamo que se muestra a continuación puede que no refleje el monto exacto de pago del préstamo. Favro de llamar a la sucursal que atiende tu cuenta, para obtener el monto de pago correcto.",
        AccountLocked:
            "Lo sentimos, pero su cuenta ha sido suspendida. Póngase en contacto con el servicio de atención al cliente.",
        AccurateInfo:
            "Todo lo que he declarado aquí es correcto a lo mejor de mi conocimiento. Entiendo que conservará la información de esta solicitud, ya sea que más tarde me aprueben para un préstamo.",
        ACHNotices: "Avisos de ACH",
        AgeVerification: "Certifico que tengo 18 años de edad.",
        AdditionalChargeDue: "Cargos adicionales",
        ApplicationComplete: "Solicitud Completa",
        ApplicationDeclined: "Solicitud Rechazada",
        ApplicationInProcess: "Solicitud En Proceso",
        ApplicationWithdrawn: "Solicitud Retirada",
        AppSent: "Tu solicitud ha sido enviada a: ",
        BankAccountType: "Tipo de cuenta bancaria",
        BiometricsEnrollment:
            "Vuelva a proporcionar tu contraseña para finalizar la inscripción en la biometría",
        BySubmitting: "Al presentar esta solicitud de préstamo,",
        CashNeeded: "¿Cuánto dinero en efectivo necesitas?",
        ChangeMyPassword: "Cambiar mi contraseña",
        ChangePassword:
            "Haga clic en el botón Enviar para enviar un código de verificación a su correo electrónico",
        Checking: "De cheques",
        ChooseLoanOffice:
            "Escoge tu sucursal.",
        CodeDescription:
            "Introduzca el código de confirmación que aparece en ese correo electrónico.",
        Confirm: "Favor de Confirmar",
        ConfirmAccount: "Confirmar cuenta",
        ConfirmationCode: "Código",
        ConfirmationCodeDescription: "Introduzca el código de confirmación",
        ConfirmationCodeLabel:
            "Para completar los cambios, introduzca el código de confirmación proporcionado.",
        ConfirmCodeText:
            "Introduzca el código de confirmación que aparece en el texto",
        ConfirmEmail: "Confirmar correo electrónico",
        ConfirmMobile: "Confirmar celular",
        ConfirmPassword: "Confirmar nueva contraseña",
        ConfirmText:
            "Para confirmar su número de teléfono, necesitaremos enviar un código de confirmación.",
        CreateAccount: "Crear su Cuenta",
        Create: "Ingresar",
        Complete: "Completo",
        Contract: "Contrato",
        Contracts: "Contratos",
        ComingSoon: "¡Próximamente!",
        CurrentPassword: "Contraseña actual",
        CurrentSelectedBranch: "Rama Seleccionada Actual",
        ContactBy: "Autorizo ​​a ser contactado a través del número de teléfono y correo electrónico proporcionado.",
        DateOfBirthDay: "Dd",
        DateOfBirthLabel: "Fecha de nacimiento (MM/DD/AAAA)",
        DateOfBirthMonth: "Mm",
        DateOfBirthYear: "Aaaa",
        DeliveryMethod: "Método de entrega",
        DocumentsNeeded: "Faltan Documentos",
        DocumentStatus_New: "Recibido",
        DocumentStatus_Pending: "Pendiente",
        DocumentStatus_UnderReview: "En revisión",
        DocumentStatus_Rejected: "Rechazado",
        DocumentStatus_Approved: "Aprobado",
        DocumentStatus_NoApplicationFound: "Aplicación no encontrada",
        ElectronicDelivery: "Financiamiento Instantáneo",
        ElectronicDeliveryComingSoon: "Financiamiento Instantáneo - ¡Próximamente!",
        EmailValidationTitle:
            "Para confirmar su nueva información, hemos enviado un correo electrónico a:",
        EmployerAddressLine2: "Línea de dirección 2 del empleador",
        EmployerCity: "Ciudad del empleador",
        Employer: "Nombre de Empleador",
        EmployerContactInformation: "Información de contacto del empleador",
        EmployerPostalCode: "Dirección zip del",
        EmployerState: "Estado del Empleador",
        EmployerStreetAddress: "Dirección del Empleador 1",
        EmployerStreetAddress2: "Dirección del Empleador 2",
        EmployerZipCode: "Dirección postal del empleador",
        EmploymentStatus: "Estado de Empleo",
        English: "Inglés",
        EnterYourPreApprovalCodeHere: "Ingrese su código de preaprobación aquí:",
        EnterBankingInfo: "Ingrese información bancaria",
        ForgotPasswordSentTo: "Olvidé la contraseña enviada a",
        ForgotPasswordSentToEmail:
            "Se ha enviado un código de confirmación a tu dirección de correo electrónico registrada.",
        ForgotPasswordSentToText:
            "Se ha enviado un código de confirmación a tu número de teléfono en el archivo.",
        FundSelection: "Selección de Fondos",
        FundingOptions: "Financiación",
        Funding: "Fondos",
        Finances: "Finanzas",
        GetStarted: "Inicio",
        GoodNews: "¡Albricias!",
        IDType: "Tipo de ID",
        IncomeFreq_BiWeekly: "Quince Dias (cada dos semanas)",
        IncomeFreq_Annual: "Anual",
        IncomeFreq_Monthly: "Mensual",
        IncomeFreq_SemiAnnual: "Semianual (dos veces al año)",
        IncomeFreq_SemiMonth: "Semimensual (dos veces al mes)",
        IncomeFreq_Weekly: "Semanal",
        IncomePerPeriod: "Ingresos por período de pago",
        IncomeSource_Alimony: "Pensión alimenticia",
        IncomeSource_ChildSupport: "Manutención de los hijos",
        IncomeSource_FullTime: "Empleado a tiempo completo",
        IncomeSource_NotEmployed: "No Empleado",
        IncomeSource_Other: "Otro tipo de ingreso",
        IncomeSource_PartTime: "Empleado de Medio tiempo",
        IncomeSource_SelfEmployed: "Cuenta Propia",
        IncomeSource_SocialSecurity: "Seguridad Social",
        IncreaseAmount: "¿Cuánto más te gustaría pedir prestado?",
        IncreaseLoan: "Refinanciar este préstamo a un monto diferente",
        InStorePickup: "Recógelo en Tienda",
        Information: "Información",
        InvalidLogin:
            'Lo sentimos, pero la contraseña que ingresaste no coincide con nuestros registros. Inténtelo de nuevo o seleccione "Olvidé mi contraseña" para obtener ayuda.\nTiene {0} más intentos antes de que su cuenta esté bloqueada por seguridad.',
        LanguageEnglish: "Inglés",
        LanguagePrefrence: "Establecer preferencia de idioma",
        LanguageSpanish: "Español",
        LateChargesDue: "Cargos atrasados",
        Letters: "Cartas",
        Lead_Applied: "En Proceso",
        Lead_Approved: "Aprobado",
        Lead_Declined: "Declinado",
        Lead_NoContact: "Sin Contacto",
        Lead_Withdrawn: "Retirado",
        LegalChargeDue: "Ajustes legales",
        Legals: "Legales",
        Licenses: "Licencias/Divulgaciones",
        LiveCheckVoidLetters: "Cartas nulas de cheques en vivo",
        LoanAmount: "Monto del préstamo",
        LoanRefinance: "Solicitud de refinanciamiento de préstamos",
        LoanRenewal: "Solicitud de renovación de préstamos",
        MilesOfZipCode: "millas de código postal",
        MinimumPaymentDue: "Pago sugerido",
        MobileOptIn: "¿Desea que le enviemos notificaciones a este número?",
        Month: "Mes",
        Months: "Meses",
        MonthsAtEmployer: "Meses",
        MyIncome: "Mi Ingreso",
        NewCustomer: "No, no he sido cliente de Sun Loan",
        NewBank: "Usar una cuenta bancaria nueva",
        NewDebitCard: "Usar una nueva tarjeta de débito",
        NewLoan: "Nueva solicitud de préstamo",
        NewLoanRefinance: "Nuevo / Refinanciar",
        NSFChargeDue: "Cargo por devolución de cheque",
        Refinance: "Refinanciamiento",
        RefinanceIncrease: "Refinanciamiento / Aumento",
        NewPassword: "Crear una nueva contraseña",
        NewLoanRequest: "Nueva Solicitud de Préstamo",
        No: "No",
        NoBranches: "Sin sucursales",
        NoCurrentLoans: "No Tienes Préstamos Actuales",
        NumberOfYearsMonthsEmployed: "Cuanto tiempo has trabajado aquí",
        OptIn: "Por favor, envíame ofertas futuras.",
        OptInCreditReport:
            "En relación con nuestra evaluación de su solicitud, usted reconoce y da su consentimiento para que podamos obtener un Informe de crédito al consumidor de una Agencia de Reporte de Crédito. Al hacerlo, podemos utilizar su número de seguro social, que necesitará proporcionarnos, su dirección y otra información que nos proporcione el cualnos ayudará a garantizar el acceso a la información correcta para la Agencia de Reporte de Crédito.",
        OtherIncomeSource: "Otro Ingreso Mensual",
        Own: "Es Dueño",
        PasswordCreate: "Crear una contraseña",
        PasswordRequirement:
            "Las contraseñas deben tener al menos 8 caracteres e incluir al menos un número, una letra mayúscula y un carácter especial.",
        PayFrequency: "¿Con qué frecuencia te pagan?",
        PaymentScheduleAmountDue: "Importe adeudado",
        PaymentScheduleDateDue: "Fecha vencida",
        PaymentsDue: "Vencido",
        PreApproved: "¿Preaprobado?",
        PreApprovedSubText: "¿Recibió un correo con un código pre aprobado?",
        PreApprovedSubText2: "De ser así, por favor haga clic abajo para ingresarlo.",
        PreApprovalCode: "Código de preaprobación",
        PrivacyPolicy: "Política de privacidad",
        ProfileChangeConfirmation:
            "Los cambios de perfil se han enviado y guardado.",
        Radius: "Radio",
        ReferralsSubmitted: "Referencias enviadas",
        ReferSomeone: "Referir a alguien",
        ReceiveAmount: "Usted recibirá:",
        RefinanceAmount: "Tu préstamo sería refinanciado para:",
        RefinanceLoan: "Refinanciar este préstamo",
        Refunds: "Reembolso",
        RememberDevice: "Recuerda este dispositivo (no selecciones si compartes este dispositivo).",
        Required: "Requerido",
        Rent: "Renta",
        ResidenceType_Other: "Otro",
        ResidenceType_Own: "Es Dueño",
        ResidenceType_Rent: "Renta",
        SavedCard: "Usar una tarjeta de débito guardada",
        Saving: "Ahorros",
        ScheduledMonthlyPayment: "Pago mensual agendado",
        Select: "Elija",
        SelectCard: "Seleccione Tarjeta guardada",
        SelectYourIdentificationType: "Seleccione el tipo de identificación",
        SendAgain: "Enviar de nuevo",
        SendAnEmailTo: "Enviar un correo electrónico a",
        SendATextTo: "Enviar un texto a",
        SendEmail: "Enviar correo electrónico",
        SendNotificationsToPhone:
            "¿Desea que te enviemos notificaciones a este número?",
        SendText: "Enviar texto",
        SetPassword: "Ingresar contraseña",
        Signup: "Alta",
        SignUpLabel:
            "Gracias por inscribirse en Sun Loan. Inicia sesión para completar tu registro y ver tu nueva cuenta.",
        SMSTerms: "Términos SMS",
        Spanish: "Español",
        SSN: "SSN o Matrícula Consular",
        SSNMatrículaConsular: "SSN o Matrícula Consular",
        SSNMatriculaConsularLabel: "Ingrese su &lt;SSN/MC&gt;",
        Submit: "Entregar",
        SuggestedBalance: "Saldo sugerido",
        SunLoanCustomer: "Sí, actualmente soy o he sido cliente de Sun Loans",
        CurrentLoanId: "ID de préstamo",
        SupportPhone: "1-800-Sun-Loan",
        TextValidationTitle:
            "Para confirmar tu información nueva, te hemos enviado un mensaje de texto a:",
        ToMakeAPayment: "Para realizar un pago sin crear una cuenta, ingrese su información a continuación.",
        TypeOfId: "Tipo de ID",
        ValidSSN:
            "Favor de ingresar su número de Seguro Social completo sin guiones",
        VerifyAge: "certifico que tengo 18 años de edad.",
        VerifyAge19: "certifico que tengo 19 años de edad.",
        VerifyConfirm: "Todo lo que he dicho aquí es correcto a mi entender. Entiendo que conservará la información de esta solicitud, ya sea que más tarde sea aprobado para un préstamo. Entiendo que Sun Loan puede comunicarse conmigo con respecto a mi solicitud.",
        VerifyOffers: "Sí, quiero recibir mensajes promocionales.",
        VerifyYourInformation: "Verifique",
        WorkNumber: "Número de Telefono de Trabajo",
        YearsAtEmployer: "Años",
        Year: "Año",
        Years: "Años",
        Yes: "Sí",
        YouEntered: "Usted ingreso",
        YourFinances: "Sus Finanzas",
        YourInformation: "Su Información",
        Veteran: "¿Es usted militar en servicio activo o dependiente de un militar en servicio activo ? ",
        Welcome: "Bienvenido",
        WhoIsYourEmployer: "Quien es tu empleador?",
        Optional: "Opcional",
    },
    Labels: {

        AccountActivityAmount: "Amount Paid",
        AccountActivityBalance: "Balance",
        AccountActivityDate: "Date Received",
        AccountActivityConvenienceFee: "Convenience Fee",
        AccountActivityToBalance: "To Balance",
        AccountActivityToOther: "To Other",
        AccountHistoryTitle:
            "The Loan Balance amount shown below may not reflect the exact loan payoff amount.  Please call your branch office for the correct payoff amount.",
        AccountInactive: "Account Inactive",
        AccountLocked:
            "We’re sorry but your account has been suspended. Please contact Customer Service.",
        AccurateInfo:
            "Everything that I have stated here is correct to the best of my knowledge. I understand that you will retain the information from this application whether or not I am later approved for a loan.",
        ACHNotices: "ACH Notices",
        AgeVerification: "I certify that I am 18 years of age.",
        AdditionalChargeDue: "Additional Charges Due",
        ApplicationComplete: "Application Complete",
        ApplicationDeclined: "Application Declined",
        ApplicationInProcess: "Application in Process",
        ApplicationWithdrawn: "Application Withdrawn",
        AppSent: "Your application has been sent to: ",
        BiometricsEnrollment:
            "Re-enter your password to finish biometrics enrollment",
        BySubmitting: "By submitting this application,",
        BankAccountType: "Bank account type",
        CashNeeded: "How much cash to do you need?",
        ChangeMyPassword: "Change My Password",
        ChangePassword:
            "Click on the send button to send a verification code to your email",
        Checking: "Checking",
        ChooseLoanOffice: "Select a branch to handle your loan.",
        CodeDescription:
            "Please enter the confirmation code provided in that email.",
        Confirm: "Please Confirm",
        ConfirmAccount: "Confirm Account",
        ConfirmationCode: "Code",
        ConfirmationCodeDescription: "Please enter the confirmation code",
        ConfirmationCodeEmailLabel:
            "To complete your changes, please enter the confirmation code provided in that email.",
        ConfirmationCodeLabel:
            "To complete your changes, please enter the confirmation code provided.",
        ConfirmationCodeTextLabel:
            "To complete your changes, please enter the confirmation code provided in that text.",
        ConfirmCodeText: "Please enter the confirmation code provided in the text",
        ConfirmEmail: "Confirm Email",
        ConfirmMobile: "Confirm Mobile",
        ConfirmPassword: "Confirm New Password",
        ConfirmText:
            "In order to confirm your phone number, we will need send a confirmation code.",
        ContactBy: "I authorize to be contacted via the phone number and email provided.",
        CreateAccount: "Create Account",
        Create: "Create",
        Complete: "Complete",
        Contract: "Contract",
        Contracts: "Contracts",
        ComingSoon: "Coming Soon!",
        CurrentAmountDue: "Current Amount Due",
        CurrentSelectedBranch: "Current Selected Branch",
        CurrentPassword: "Current Password",
        DateOfBirthDay: "DD",
        DateOfBirthLabel: "Date of Birth (MM/DD/YYYY)",
        DateOfBirthMonth: "MM",
        DateOfBirthYear: "YYYY",
        DeliveryMethod: "Delivery Method",
        DocumentsNeeded: "Documents Needed!",
        DocumentStatus_New: "Received",
        DocumentStatus_Pending: "Pending",
        DocumentStatus_UnderReview: "Under Review",
        DocumentStatus_Rejected: "Rejected",
        DocumentStatus_Approved: "Approved",
        DocumentStatus_NoApplicationFound: "No Application Found",
        ElectronicDelivery: "Instant Funding",
        ElectronicDeliveryComingSoon: "Instant Funding - Coming Soon!",
        EmailValidationTitle:
            "To confirm your new information, we have sent an email to:",
        EmployerAddressLine2: "Employer Address Line 2",
        EmployerCity: "Employer City",
        Employer: "Employer Name",
        EmployerContactInformation: "Employer contact information",
        WhoIsYourEmployer: "Who is your employer?",
        EmployerPostalCode: "Zip Code",
        EmployerState: "Employer State",
        EmployerStreetAddress: "Employer Street Address",
        EmployerStreetAddress2: "Employer Street Address 2",
        EmployerZipCode: "Employer Zip Code",
        EmploymentStatus: "Employment Status",
        English: "English",
        EnterBankingInfo: "Enter Banking Info",
        EnterYourPreApprovalCodeHere: "Enter your pre-approval code here:",
        ForgotPasswordSentTo: "Forgot Password Sent to",
        ForgotPasswordSentToEmail:
            "A confirmation code has been sent to your email address on file.",
        ForgotPasswordSentToText:
            "A confirmation code has been sent to your phone number on file.",
        Finances: "Finances",
        FundSelection: "Fund Selection",
        Funding: "Funding",
        FundingOptions: "Funding",
        GetStarted: "Get Started",
        GoodNews: "Good News!",
        IDType: "ID Type",
        IncomeFreq_BiWeekly: "Bi-Weekly (every other week)",
        IncomeFreq_Annual: "Annual",
        IncomeFreq_Monthly: "Monthly",
        IncomeFreq_SemiAnnual: "Semi-Annual (twice a year)",
        IncomeFreq_SemiMonth: "Semi-Monthly (twice a month)",
        IncomeFreq_Weekly: "Weekly",
        IncomePerPeriod: "Net income Per Pay Period",
        IncomeSource_Alimony: "Alimony",
        IncomeSource_ChildSupport: "Child Support",
        IncomeSource_FullTime: "Employed Full Time",
        IncomeSource_NotEmployed: "Not Employed",
        IncomeSource_Other: "Other",
        IncomeSource_PartTime: "Employed Part Time",
        IncomeSource_SelfEmployed: "Self Employed",
        IncomeSource_SocialSecurity: "Social Security",
        IncreaseAmount: "How much cash do you need?",
        IncreaseLoan: "Refinance this loan to a different amount",
        IncreaseLoanRequest: "Loan Increase Request",
        InStorePickup: "In Store Pickup",
        InvalidLogin:
            "Sorry, but the password you entered doesn’t match our records. Try again or select “Forgot My Password” for help.\nYou have {0} more tries before your account is locked for safety.",
        Information: "Information",
        LanguageEnglish: "English",
        LanguagePrefrence: "Set Language Preference",
        LanguageSpanish: "Español",
        LateChargesDue: "Late Charges Due",
        Letters: "Letters",
        Lead_Applied: "Processing",
        Lead_Approved: "Approved",
        Lead_Declined: "Declined",
        Lead_NoContact: "No Contact",
        Lead_Withdrawn: "Withdrawn",
        LegalChargeDue: "Legal Charges Due",
        Legals: "Legals",
        Licenses: "Licenses/Disclosures",
        LiveCheckVoidLetters: "Live Check Void Letters",
        LoanAmount: "Loan Amount",
        LoanRefinance: "Loan Refinance Request",
        LoanRenewal: "Loan Renewal Request",
        MilesOfZipCode: "miles of zip code",
        MinimumPaymentDue: "Suggested Payment",
        MobileOptIn: "Would you like for us to send notifications to this number?",
        Month: "Month",
        Months: "Months",
        MonthsAtEmployer: "Months",
        MyIncome: "My Income",
        NewCustomer: "No, I have not been a Sun Loan customer",
        NewBank: "Use a new bank account",
        NewDebitCard: "Use a new debit card",
        NewLoan: "New Loan Request",
        NewLoanRefinance: "New / Refinance",
        NSFChargeDue: "Returned Check Charges",
        ReEnterSocialSecurity: "ReEnterSocialSecurity",
        Refinance: "Refinance",
        RefinanceIncrease: "Refinance / Increase",
        NewLoanRequest: "New Loan Request",
        NewPassword: "Create a New Password",
        No: "No",
        NoBranches: "No Branches",
        NoCurrentLoans: "No Current Loans",
        NumberOfYearsMonthsEmployed: "How long have you worked here",
        OptIn: "Please send me future offers.",
        OptInCreditReport:
            "In connection with our evaluation of your application, you acknowledge and consent that we may obtain a Consumer Credit Report from a Credit Reporting Agency. In doing so, we may use your social security number which you provide, your address and other information you give us to help assure that we access the correct information for the Credit Reporting Agency",
        OtherIncomeSource: "Other Income Source",
        Own: "Own",
        PasswordCreate: "Create a Password",
        PasswordRequirement:
            "Passwords must be at least 8 characters long and include at least one number, one capital letter and one special character.",
        PayFrequency: "How often do you get paid?",
        PayPeriodFrequency: "Pay Period Frequency",
        PaymentsDue: "Past Due",
        PaymentScheduleAmountDue: "Amount Due",
        PaymentScheduleDateDue: "Date Due",
        PreApproved: "Pre-Approved?",
        PreApprovedSubText: "Did you receive a mail piece with a pre-approval code?",
        PreApprovedSubText2: "If so, please click below to enter it.",
        PreApprovalCode: "Pre-Approval Code",
        PrivacyPolicy: "Privacy Policy",
        ProfileChangeConfirmation:
            "Your profile changes have been submitted and saved.",
        Radius: "Radius",
        ReferralsSubmitted: "Referrals Submitted",
        ReferSomeone: "Refer Someone",
        ReceiveAmount: "You will receive:",
        RefinanceAmount: "Your loan would be refinanced to:",
        RefinanceLoan: "Refinance the Loan",
        RefinanceLoanRequest: "Refinance Loan Request",
        Refunds: "Refunds",
        RemainingLoanAmount: "Remaining Loan Amount",
        RememberDevice: "Remember this device (uncheck for shared device).",
        RenewLoanRequest: "Loan Renewal Request",
        Rent: "Rent",
        Required: "Required",
        ResidenceType_Other: "Other",
        ResidenceType_Own: "Own",
        ResidenceType_Rent: "Rent",
        SavedCard: "Use a saved debit card",
        Saving: "Saving",
        ScheduledMonthlyPayment: "Scheduled Monthly Payment",
        Select: "Select",
        SelectCard: "Select Saved Card",
        SelectYourIdentificationType: "Select your identification type",
        SendAgain: "Send Again",
        SendAnEmailTo: "Send an email to",
        SendATextTo: "Send a text to",
        SendEmail: "Send Email",
        SendNotificationsToPhone:
            "Would you like for us to send notifications to this number?",
        SendText: "Send Text",
        SetPassword: "Set Password",
        Signup: "Sign Up",
        SignUpLabel:
            "Thank you for signing up with Sun Loan. Sign in to complete your registration and view your new account.",
        SMSTerms: "SMS Terms",
        Spanish: "Español",
        SSN: "SSN or Matrícula Consular",
        SSNMatrículaConsular: "SSN or Matrícula Consular",
        SSNMatriculaConsularLabel: "Please Enter Your <SSN/MC>",
        Submit: "Submit",
        SuggestedBalance: "Suggested Balance",
        SunLoanCustomer: "Yes, I am currently or have previously been a Sun Loan customer",
        CurrentLoanId: "Loan ID",
        SupportPhone: "1-800-Sun-Loan",
        TextValidationTitle:
            "To confirm your new information, we have sent an text to:",
        ToMakeAPayment: "To make a payment without creating an account, please enter your information below.",
        TypeOfId: "ID Type",
        ValidSSN:
            "Please enter a Social Security Number consisting of 9 numbers without dashes",
        VerifyAge: "I certify that I am 18 years of age.",
        VerifyAge19: "I certify that I am 19 years of age.",
        VerifyConfirm: "Everything that I have stated here is correct to the best of my knowledge. I understand that you will retain the information from this application whether or not I am later approved for a loan. I understand that Sun Loan may contact me regarding my application.",
        VerifyConsent: "In connection with our evaluation of your application, you acknowledge and consent that we may obtain a Consumer Credit Report from a Credit Reporting Agency. In doing so, we may use your social security number which you provide, your address and other information you give us to help assure that we access the correct information for the Credit Reporting Agency.",
        VerifyOffers: "Yes, I want to receive Promotional messages.",
        VerifyYourInformation: "Verify",
        Veteran: "Are you active duty military or an active duty military dependent?",
        WorkNumber: "Work Phone",
        Year: "Year",
        Years: "Years",
        YearsAtEmployer: "Years",
        Yes: "Yes",
        YouEntered: "You entered",
        YourFinances: "Your Finances",
        YourInformation: "Your Information",
        Welcome: "Welcome",
        YourPersonalInfo: "Let's go over your personal information",
        Optional: "Optional",
    },
    "Menu.es": {
        AccountHistory: "Historial de cuentas",
        CustomerService: "Servicio al cliente",
        Home: "Casa",
        IncreaseRefinance: "Aumento o Refinanciamiento",
        LogIn: "Iniciar sesión",
        LogOut: "Cerrar sesión",
        MyAccount: "Mi cuenta",
        MyDocuments: "Mis documentos",
        MyProfile: "Mi perfil",
        PrivacyPolicy: "Política de privacidad",
        ReferFriend: "Referir a un amigo",
        Register: "Registro",
        RequestNewLoan: "Solicitar un préstamo nuevo ",
        SecureUpload: "Carga segura",
    },
    Menu: {
        AccountHistory: "Account History",
        CustomerService: "Customer Service",
        Home: "Home",
        IncreaseRefinance: "Increase or Refinance",
        LogIn: "Login",
        LogOut: "Log Out",
        MyAccount: "My Account",
        MyDocuments: "My Documents",
        MyProfile: "My Profile",
        PrivacyPolicy: "Privacy Policy",
        ReferFriend: "Refer a Friend",
        Register: "Register",
        RequestNewLoan: "Request a New Loan",
        SecureUpload: "Secure Upload",
    },
    "Messages.es": {
        AccountNotAvailableFooter:
            "Por favor, revisa tu cuenta 48-72 horas después de que tu préstamo haya sido aprobado o pónte en contacto con el servicio de atención al cliente si crees que hay un problema con tu cuenta. ",
        AccountNotAvailableHeader:
            "Los registros de tu cuenta no están disponibles en este momento. Esto podría deberse a: ",
        AccountNotAvailableReason1: "Tu préstamo aún no ha sido proceso. ",
        AccountNotAvailableReason2:
            "Hay errores o datos no coincidentes en la información de tu cuenta. ",
        ACHpayment: "Si está configurado, su pago ACH se realizará incluso si realiza un pago en línea hoy, lo que puede resultar en pagos duplicados. Si tiene alguna pregunta, comuníquese con Servicio al Cliente al 1-800-SUN-LOAN",
        ACHNextInstallment: "Fecha programada de pago ACH {0} para {1}",
        ACHPaymentFailed: "Tu último pago ACH no funcionó. Favor de intentar nuevamente utilizando una tarjeta de débito.",
        AnUnexpectedErrorHasOcurred: "Se ha producido un error inesperado. Vuelva a intentar su solicitud.",
        AdditionalDocumentsAreRequired1: "Se requieren documentos adicionales para continuar procesando su solicitud de préstamo. Vaya a ",
        AdditionalDocumentsAreRequired2: " Para completar este paso",
        AllDocumentsSubmitted: "Todos los documentos han sido enviados",
        ApplicationCompletedElectronic: "La cantidad que solicitó se depositará dentro de las 24 horas.",
        ApplicationCompletedInPerson: "Puede recoger sus fondos en su sucursal de Sun Loan:",
        ApplicationDeclined: "En unos días te llegará una carta explicando nuestra decisión. Queremos asegurarte que esto no afectará tu puntaje crediticio.*",
        ApplicationDeclined2: "Podemos conectarte con una red de prestamistas que podrían ayudarte. Haz clic en ",
        ApplicationDeclined3: " para encontrar otras opciones que puedan funcionar para usted.",
        ApplicationProcessing: "Estamos revisando tu solicitud. Esto no tomará mucho tiempo; tendrás noticias en breve.",
        ApplicationProcessing2: "¡Gracias por confiar en nosotros para tus necesidades financieras!",
        ApplicationInProcess: "Solicitud en proceso",
        ApplicationPreapproved: "Has sido precalificado para recibir hasta ${0}",
        ApplicationPreapprovedCongratulations: "¡Felicidades! Has sido precalificado para recibir hasta ${0}",
        ArgumentRequiredOrIncorrectFormat: "Falta información o está incorrecta.",
        AreYouSurePerformAction: "¿Estás seguro de que quieres realizar la acción?",
        AsShownOnID: "Como aparece en tu Identificación Oficial",
        BankruptcyMessage:
            "Sun Loan ha sido notificado de que estas en el proceso de declararte en bancarrota o ya lo has hecho.  Como resultado, tu cuenta ha sido suspendida.  Si tienes alguna pregunta, pónte en contacto con tu sucursal o llama al servicio de atención al cliente al {0}.",
        BorrowerMustBe18: "Borrowers must be 18 years of age.",
        ByCheckingThisBox: "Al marcar esta casilla, doy mi consentimiento para ser contactado a través de teléfono celular o número telefónico de casa proporcionados personalmente. Doy autorización a recibir información sobre productos y servicios ofrecidos por o en nombre de Sun Loan a través de llamadas telefónicas, mensajes de texto y mensajes pregrabados por medio de tecnología automatizada, que incluye marcadores automáticos. Pueden aplicarse tarifas de mensajes y datos.",
        ByCheckingThisBox2: "Condiciones de uso de SMS.",
        ByCheckingThisBox3: " Mi consentimiento no es una condición para el préstamo y no afectará la decisión por parte de  Sun Loan de otorgar el préstamo o no.",
        CallOrText1: "Es posible que recibas",
        CallOrText2: "una llamada o un mensaje de texto",
        CallOrText3: "a este número de teléfono, con información importante acerca de tu solicitud o cuenta",

        ChangeMyContactInformation: "Cambiar mi información de contacto",
        ChangeMyFinancialInformation: "Cambiar mi información financial",
        ChooseHowYouToReceiveFunds: "Escoja cómo le gustaría recibir sus fondos",
        ChooseLoanOffice: "Recibe tu dinero en línea o en sucursal.*",
        ChooseLoanOfficeDisclaimer: "* Para poder recibir los fondos de tu préstamo de forma remota, debes vivir en el estado donde se encuentra tu sucursal.",
        CompleteRequiredFields: "Por favor complete los campos requeridos",
        ConfirmEmail:
            "El correo electrónico y confirmación el correo electrónico deben ser los mismos",
        ConfirmPassword: "Confirmar contraseña",
        ConfirmAccountNumber: "El número de cuenta y el número de cuenta confirmado deben ser iguales.",
        ConfirmRoutingNumber: "El número de ruta y el número de ruta confirmado deben ser iguales.",
        Copyright: "© Copyright {0} Sun Loan Company. Reservados todos los derechos.",
        ConfirmRefinanceIncrease:
            "Llame o venga para completar el proceso de préstamo. De lo contrario, alguien se pondrá en contacto con usted pronto para ayudarle a completar su préstamo.",
        ConfirmRemoveSavedPaymentMethod: "¿Estás seguro que deseas eliminar este método de pago?",
        ContactCustomerSupport:
            "Para preguntas sobre tu préstamo o el estado de una solicitud de préstamo, comunícate con Atención al cliente al:",
        ContactInformationOnFile: "la información de contacto en el archivo",
        ContactLocalBranch:
            "Para preguntas sobre tu préstamo o el estado de una solicitud de préstamo, comunícate con su sucursal local:",
        Continue: "Continuar",
        CouldNotCompleteOperation: "No se pudo completar la operación.",
        CouldNotCreateAccount:
            "No hemos podido crear tu cuenta en este momento. Inténtalo de nuevo o pónte en contacto con el servicio de atención al cliente para obtener ayuda.",
        DeleteSavedPaymentFailed:
            "No se han podido eliminar uno o varios de los métodos de pago guardados. La lista de pagos se ha actualizado.",
        DidntGetCode: "¿No recibiste un código?",
        DocumentLink1Message: "Por favor ve a ",
        DocumentLink2Message: "para los siguientes pasos",
        DocumentLink: " 'Mis Documentos'",
        DocumentName: "Nombre del documento: {0}",
        DocumentsNotFound: "No Hay Documentos",
        DocumentProofSubmitted: "Tu {0} ha sido enviada.",
        DocumentOptionsText: "Tiene algunas opciones fáciles para enviar sus documentos para continuar con su solicitud",
        DocumentRejected: "Notificación de documento!",
        DocumentsAccepted: "{0} de {1} documentos aceptados",
        DocumentsUploaded: "{0} de {1} documentos subidos",
        DocumentUploadSuccessful: "La carga del documento fue exitosa.",
        DocumentSecureUpload: '<p class="mb-0 pb-0">Favor cargar el documento requerido</p><p class="mt-0 pt-0">Los documentos pueden tardar hasta un minuto en cargarse</p>',
        DocumentSecureUploadDocument: "Documento Aceptado",
        DocumentSecureUploadDocuments: "Documentos Aceptados",
        DocumentStatus: "Estado: {0}",
        DocSunLoanEmail: "upload@sunloan.com",
        DocSunLoanPhone: "1-726-201-0818",
        ElectronicDelivery: "Colectaremos la información de su tarjeta de débito durante la llamada telefónica de verificación.",
        EmailHasIncorrectFormat:
            "El correo electrónico no está en el formato correcto",
        EmailInUsePleaseLogin: "Correo electrónico en uso, favor de iniciar su sesión.",
        ExpediteTheDocument: "Para agilizar el proceso de revisión de documentos, envía mensajes de texto y correos electrónicos desde el número de teléfono o correo electrónico que aparece en tu solicitud",
        ExistingCustomerRegistrationIdentity1: "Favor de proporcionar tu número de seguro social y fecha de nacimiento a continuación para crear tu cuenta en my.sunloan.com.",
        ExistingCustomerRegistrationIdentity2: "<p>Para verificar tu cuenta, te enviaremos un código de verificación al correo electrónico registrado en Sun Loan. Si ya no tienes acceso al correo electrónico registrado, actualízalo visitando tu sucursal o llamando al 1-800-Sun-Loan.</p><p>Este correo electrónico será tu nombre de usuario cuando inicies una sesión en my.sunloan.com.</p>",
        ExistingEmailValidation: "Si nuestros archivos encuentran tu fecha de nacimiento y número de seguro social, te enviaremos un código de confirmación al correo electrónico registrado en Sun Loan. Si ya no tienes acceso al correo electrónico registrado, visita tu sucursal o llama al 1-800-Sun-Loan.",
        ReCaptchaFailed: "El código de CAPTCHA no pudo ser verificado",
        Error404NotFound: "Error 404: No Encontrado",
        ErrorCannotFindLoan: 'Estamos teniendo problemas para encontrar su préstamo. Para realizar un pago, <a href="https://my.sunloan.com/">inicie sesión</a> o <a href="https://my.sunloan.com/SignUpCustomerStatus">regístrese</a>.',
        ErrorInvalidLeadToken: "Llame al 1-844-Sun-Loan para obtener ayuda.",
        Error_PaymentIsPending:
            "No se puede realizar un pago de un préstamo mientras otro pago está pendiente.",
        ErrorUploadingDocument: "Error al cargar el documento",
        Find_Office:
            "Primero, busquemos una oficina de préstamos cerca de ti para atender tu préstamo.",
        FileSizeErrorTitle: "Vaya, el tamaño del archivo supera el límite de 10 MB.",
        FileTypeErrorTitle: "Tipo de archivo no soportado.",
        FilesAllowedErrorTitle: "Vaya, el número de archivos supera el límite permitido.",
        FilesAllowedErrorText: "Intente con menos archivos.",
        FileSizeErrorText: "Intente con un archivo diferente.",
        FileTypeErrorText: "No admitimos ese tipo de archivo.",
        FooterLenderComplaint: '<p>PARA REPORTAR UN PROBLEMA O QUEJA CON ESTE PRESTAMISTA, PUEDE ESCRIBIR O LLAMAR: Compliance Department, 1020 NE Loop 410, Ste 380, San Antonio TX 78209, <a href="tel:8005317652">800-531-7652</a>, <a href="mailto:contact@sunloan.com">contact@sunloan.com</a></p>',
        ForgoPasswordSendTo:
            "Podemos enviar un correo electrónico o un mensaje de texto a su teléfono móvil.",
        ForgotPassword:
            "Para recuperar tu contraseña, necesitaremos enviar un código de restablecimiento de contraseña.",
        ForgotPasswordChanged:
            "Tu contraseña ha cambiado. Por favor, vuelve a la pantalla de inicio de sesión para iniciar sesión con tu nueva contraseña. ",
        ForgotPasswordMfaSentMessage:
            "Si la información que ingresaste coincide con nuestros registros, se te enviará un código. Introduce el código aquí para confirmar tu identidad y restablecer tu contraseña. Si no recibes un código, pónte en contacto con el servicio de atención al cliente para obtener más ayuda.",
        ForgotPasswordWrongAnswerSubtitle1:
            "Lo sentimos, pero las respuestas que proporcionaste no coinciden con la información que tenemos registrada para esta cuenta. Puedes intentarlo de nuevo o solicitar o contáctanos para obtener ayuda.",
        ForgotPasswordWrongAnswerSubtitle2:
            "Tienes {0} más intentos disponibles antes de que tu cuenta sea bloqueada por seguridad.",
        FormValid: "Corrige los errores y vuelve a enviar el formulario",
        ForTheInitialPurpose: "* El proceso inicial de precalificación para un préstamo, requiere información crediticia de una o más agencias de informes crediticios. Esta información se obtiene mediante una consulta crediticia “suave”, que no afecta su puntaje crediticio. Si se la solicitud de préstamo se aprueba el préstamo y usted lo acepta, obtendremos un informe de crédito del consumidor completo de una o más agencias de informes de crédito; esta solicitud de un informe crediticio resultará en una investigación crediticia “dura” y puede afectar su puntaje crediticio.",
        GoodNews: "Un prestamista está listo para trabajar contigo. Haz clic en ", 
        GoodNews2: " para conectarte con ellos.", 
        SuspendedFlagMessage:
            "Tu tu cuenta ha sido suspendida. Si tienes alguna pregunta, pónte en contacto con tu sucursal o llama al servicio de atención al cliente al {0}.",
        IdMissing:
            "¡Identificación necesaria!",
        IdFront:
            "Foto del frente de identidad",
        IdBack:
            "Foto de Identidad Volver",
        InOffice: "Es posible que una de nuestras sucursales pueda ayudarlo en persona.",
        IfYouHaveAnyQuestions: "Si tiene alguna pregunta sobre el estado de su solicitud, llame al 1-800-SUN-LOAN (1-800-786-5626) y podremos ayudarlo.",
        includesSchedule:"(Esto incluye su pago mensual programado y cargos)",
        IncreaseLoanText:
            "Esto aumentará este monto original de su préstamo. Se le pagará la diferencia y su pago mensual aumentará.",
        IncreaseRefinanceDisclaimer: "* Sujeto al reglamento y aprobación de crédito.",
        InstantFunding:
            "Una vez aprobada y aceptada tu solicitud, debes ingresar la información de tu tarjeta de débito para que el dinero correspondiente a tu préstamo pueda ser depositado directamente a tu cuenta bancaria. No habrá cargos asociados con esta transacción. No se aceptan tarjetas de crédito.",
        InvalidAuthenticationCode:
            "No se pudo validar el código que se proporcionó. ",
        InvalidFormat: "Formato no válido",
        InvalidSSN: "Invalid Social Security Number.",
        InvalidITINLength: "Invalid Individual Tax Identification Number (ITIN) must be 9 digits.",
        ITINError: "Invalid Individual Tax Identification Number (ITIN).",
        LPXAppInProcess: "<p><strong>Espera una llamada de nosotros</strong></p><p>Puede ser que recibas una llamada de nuestros Especialistas en Préstamos desde nuestro Centro de Servicio en San Antonio, TX, o de tu sucursal local.</p><p><strong>Prepárate para proporcionar información adicional</strong></p><p>Es posible que necesites proporcionar información adicional, como: Comprobante de ingresos e identificación. Puedes hacerlo enviando esos documentos por correo electrónico a <a href='mailto:docs@sunloanonline.com'>docs@sunloanonline.com</a>, enviándolos por mensaje de texto al 1-726-201-0818 ó subiéndolos a la página <a href='/my-documents'>Mis documentos</a>.</p><p><strong>Recibe tus fondos</strong></p><p>¡Obtén fondos tan rápido como hoy! Durante nuestro horario normal de trabajo, podemos proporcionarte el dinero de tu préstamo tan pronto como el mismo día de tu solicitud.</p>",
        LoanInstructions:
            "Este formulario en línea no es una solicitud de préstamo completa y solo sirve con el propósito de recopilar información de contacto preliminar. Nuestro personal de la oficina se pondrá en contacto contigo dentro de las 24 horas (excepto los fines de semana y días festivos) para completar el proceso de solicitud. Debes completar nuestra solicitud con la sucursal (por teléfono o en persona) y el préstamo debe finalizarse en la sucursal en persona.",
        LoanSentTo: "Tu Solicitud de Préstamo ha sido enviada a:",
        LoanNumber: `Número de préstamo: {0}`,
        LocateWithin: "Localiza las oficinas de préstamos de Sun dentro de:",
        Maintenance: "Nuestros desarrolladores están realizando mantenimiento programado. Estaremos de vuelta lo antes posible. Perdón por cualquier inconveniente.",
        MessageBodyNotSupplied:
            "Se requiere el cuerpo del correo electrónico o el modelo identificador. ",
        MfaConfirmSent: "Por tu seguridad, necesitamos verificar tu identidad.",
        MfaEnterConfirmInfo:
            "Para verificar tu identidad, proporciona el código de confirmación a continuación.",
        MfaWillConfirmEmail:
            "Por tu seguridad, necesitamos verificar tu identidad y enviaremos un código de verificación a la dirección de correo electrónico registrada. Haz clic a continuación.",
        MfaWillConfirmPhone:
            "Para su seguridad, necesitamos verificar su identidad y enviaremos un código de verificación al teléfono. Haga clic en Siguiente continuar.",
        MobileOptIn:
            "Necesitamos confirmar su número de teléfono móvil y enviaremos un código de verificación a su nuevo número de teléfono móvil. Haga clic al lado para continuar. ",
        MobilePhoneError: "Favor de entrar un numero de telefono que contiene 10 numeros y que no empieza con un 0 o 1.",
        MoreInformation: "Para determinar si otro prestamista puede ofrecerle un préstamo, proporcione algunos detalles adicionales. Su información está encriptada de forma segura y solo se utilizará para esta solicitud.*",
        NewCustomers: "*Los clientes nuevos con préstamos mayores de $1800, deben recoger sus fondos en la sucursal.",
        NoBusinessInState: "Desafortunadamente, no ofrecemos ningún producto en su estado.",
        NoContractsFound: "No se encontraron documentos de contrato",
        NoACHNoticesFound: "No se encontraron documentos de Aviso de ACH",
        NoBranchNearYou: "Lo sentimos, no tenemos sucursales dentro de 50 millas de su ubicación.",
        NoLiveCheckVoidLettersFound: "No se encontraron documentos de Cartas nulas de cheques en vivo",
        NoLegalsFound: "No se encontraron documentos Legales",
        NoLettersFound: "No se encontraron documentos de carta",
        noIdsFound: "No se encontraron documentos de identificación",
        NoLocationFound:
            "Desafortunadamente, no tenemos una ubicación de Préstamo Sun dentro de {0} millas de código postal {1}. Actualmente tenemos oficinas en Alabama, Illinois, Missouri, Nevada, Nuevo México, Oklahoma y Texas. Por favor, cambie sus criterios de búsqueda para encontrar una oficina cerca de usted.",
        NoOffers: "Tras revisar la información proporcionada, la red de prestamistas no pudo asignarle un agente de préstamos. Agradecemos que haya probado esta opción.",
        NotPayoffAmount:
            "Este no es el monto de liquidación anticipada de su préstamo. Si desea liquidar este préstamo anticipadamente, llame {0}.",
        NumericValue: "Solo se permiten números",
        OneOfOurRepresentatives: "Uno de nuestros representantes lo llamará desde nuestro Centro de Servicio al Cliente en San Antonio, TX usando un número de teléfono con un código de área 210 O desde una sucursal local lo antes posible. Esta convocatoria puede incluir una solicitud de información adicional necesaria para completar el proceso.",
        Or: "O",
        OtherQuestions:
            "Para todas las demás preguntas, llame al Servicio de Atención al Cliente al: ",
        OtherAmount: `Tenga en cuenta que {0} es menor que la cantidad adeudada de {1}`,
        PasswordDisplayLengthError:
            "El {0} debe tener al menos {2} y un máximo de {1} caracteres.",
        PasswordRequirements:
            "Las contraseñas deben tener al menos 8 caracteres e incluir al menos un número (1, 2, 3, etc), una letra mayúscula (R, T ,N, etc) y un carácter especial (&, %, !, etc).",
        PasswordsDoNotMatch:
            "La confirmación de la contraseña no coincide con la contraseña.",
        PaymentDeclined: "Tu último pago fue rechazado.",
        PaymentInProcess: "Tienes un pago en proceso.",
        PaymentPastDue: "El pago está vencido",
        PayoffAtBranch:
            "La cantidad para liquidar el préstamo en {0} era de ${1}. No pagues más de la cantidad indicada. Para cualquier pregunta llama a tu sucursal al {2} o al {3}.",
        PayoffAtCustomerService:
            "La cantidad para liquidar el préstamo en {0} era de ${1}. No pagues más de la cantidad indicada. Para cualquier pregunta llama a tu sucursal o al {2}.",
        PayByBankHeader: "Paga a través de cuenta bancaria",
        PayByBank: "Paga usando tu cuenta bancaria. No hay cargo adicional por este servicio.",
        PayByCardHeader: "Paga con tarjeta de débito",
        PayByCard: "Paga usando tu tarjeta de débito. Aplica un cargo de ${0} al momento de hacer el pago. Sun Loan no recibe ninguna parte de este cargo.",
        PayByCardNoFee: "Paga usando tu tarjeta de débito.",
        PaymentSuccessNewAccount: "¡Crea una cuenta hoy!",
        PaymentSuccessExistingAccount: "¡Inicie sesión en su cuenta hoy!",
        PaymentSuccessNewAccount1: "Acceso a la cuenta 24 horas al día, 7 días a la semana",
        PaymentSuccessNewAccount2: "Realizar un pago",
        PaymentSuccessNewAccount3: "Solicitar un refinanciamiento o un aumento de préstamo",
        PaymentSuccessNewAccount4: "Consulta el saldo de tu cuenta",
        PaymentSuccessNewAccount5: "& ¡más!",
        PleaseCompleteReferralBeforeAdding:
            "Por favor, completa toda la información de tu primera referencia antes de agregar una nueva.",
        PleaseCompleteSteps: "Para continuar con el proceso de tu solicitud, por favor carga los siguientes documentos:",
        PleaseCompleteSteps1: "Identificación oficial vigente con fotografía.",
        PleaseCompleteSteps2: "Tu recibo de nómina más reciente u otro comprobante de ingresos.",
        PleaseCompleteSteps3: "Dos recibos recientes de servicios (como luz, agua o teléfono) que muestren tu domicilio.",
        PleaseProvideUsWithMoreInformation:
            "Favor de proporcionar información adicional para confirmar su identificación",
        PleaseSubmitNewDocument: "Por favor, envíe un nuevo documento",
        PreApprovalCodeInvalid: "¡Perdón! No podemos verificar la información que ingresó.",
        ProfileChangesSubmitted:
            "Tu perfil se ha publicado correctamente para su procesamiento. Los cambios pueden tardar unos minutos en reflejarse en tu cuenta.",
        ProofOfIdentity: "Cargue el frente de su identificación emitida por el gobierno o el estado",
        ProofOfResidence:
            "Cargue dos facturas diferentes u otro artículo con su dirección",
        ProofOfIncome:
            "Cargue su último comprobante de pago y otra prueba de ingresos",
        PostalCodeError: "Ingrese un código postal válido de 5 dígitos.",
        ReferAFriendPara1:
            "Obtén la oportunidad de ganar hasta $100* cuando recomiendas a un amigo, compañero de trabajo o familiar.",
        ReferAFriendPara2:
            "Escribe tu nombre y correo electrónico a continuación y nosotros te enviaremos una invitación para aplicar de tu parte. ¡Es así de simple!",
        ReferAFriendPara3:
            "La mejor parte es que ¡no hay límite en la cantidad de personas que puedes recomendarnos!",
        ReferralMessage1:
            "¡Un amigo al que te refirió se ha registrado con nosotros! Por favor, ven a tu sucursal de Préstamo solar para recoger tu pago por la referencia.",
        ReferralMessage2: "¡Gracias por la referencia!",
        ReferAFriendDisclaimer:
            "* Sujeto a la realización del préstamo. Para mayor información llame a su sucursal",
        ReferralsEarned: "¡Ganaste una comisión por referir a alguien!",
        ReferralSubmittedPara1: "Gracias por tu referencia.",
        ReferralSubmittedPara2:
            "Por favor, asegúrate de decirle a tus amigos o familiares acerca de tu referencia y pídeles que compartan su nombre con nosotros cuando soliciten un préstamo.",
        ReferralSubmittedPara3:
            "Enviaremos un correo electrónico de tu parte. Una vez que recibamos respuesta de ellos, nos pondremos en contacto contigo.",
        RefinanceLoanText:
            "Esto restablecerá el monto de tu préstamo y el plazo del préstamo al monto original. Se te pagará la diferencia.",
        RequestedAmountInvalid: "La cantidad solicitada no es válida.",
        RequestedAmountMin: "El mínimo monto solicitado no debe ser menos de ${1}.",
        RequestedAmountMax: "El máximo monto solicitado no debe ser más de ${1}.",
        RequiredField: "No puede dejarse en blanco",
        RequiredFieldNotSupplied: "Se requiere un valor para {0}.",
        SocialSecurityDoesNotMatch: "Asegúrate que los números sean los mismos en ambos renglones.",
        TaxIdentificationDoesNotMatch: "Asegúrate que los números sean los mismos en ambos renglones.",
        ReviewFollowingSections: "* Por favor revise las siguientes secciones antes de enviar:",
        SessionTimeout:
            "Tu sesión está a punto de caducar debido a inactividad. Haz clic en Continuar para continuar con tu sesión.",
        SuccessOperation: "La operación se completó correctamente.",
        TakePicture: "Envía un texto con la foto del documento al 1-726-201-0818. *Envía un mensaje de texto por cada documento; luego espera una confirmación antes de enviar el siguiente documento",
        TakePictureProofs: "Tome una foto de su licencia de conducir actual, dos facturas recientes con su dirección, un talón de pago actual y otra prueba de empleo y envíe un correo electrónico o cargue la foto usando el formulario a continuación.",
        TakePictureProofsWithTexting: "Tome una foto de su licencia de conducir actual, dos facturas recientes con su dirección, un talón de pago actual y otra prueba de empleo y envíe un correo electrónico, texto o cargue la foto usando el formulario a continuación.",
        TextMessageNumberIncorrectFormat:
            "El número de mensajería de texto de destino debe ser +1 seguido del número de 10 dígitos.",
        ThankYou: "Gracias!",
        ThankYouDocsSubmitted: "Gracias. Todos los documentos han sido enviados",
        ThankYouDocsSubmittedReviewed: "Gracias. Todos los documentos han sido enviados y están siendo revisados.",
        ThirdParty: "Nuestros registros indican que su cuenta fue cancelada y ha sido transferida a {0} para su cobro. Por favor llame a {0} al <a href='tel:{1}'>{2}</a> de lunes a jueves, de {3} a {4}; viernes, de {5} a {6} para hacer los arreglos de pago. O visite <a href='{7}'>{7}</a> para realizar un pago.",
        ThisEmail: 'Esta dirección de correo electrónico será tu nombre de usuario. También lo usaremos para',
        ThisEmail2: 'comunicarnos contigo',
        UserHashMatchFound: "Parece que ya tiene una cuenta en sunloan.com. Inicie sesión a continuación para enviar su solicitud.",
        UnableToCompleteRequest: "Desafortunadamente, no podemos completar tu solicitud en este momento.",
        UnfortunatelyUnableToProcess1: "Desafortunadamente, no podemos aprobar su solicitud en este momento. Por favor, vaya a ",
        UnfortunatelyUnableToProcess2: " para más detalles.",
        UnregisteredDevice: "Este dispositivo no está registrado en tu cuenta. Para tu seguridad, debemos registrarlo enviando un código de verificación a {0}.",
        UploadFiles: "Subir archivos",
        UploadUsingForms: "Sube tus documentos a continuación",
        UploadPictureTo: "Envía tus documentos por correo electrónico a",
        UpdatedAt: "Última actualización: {0}",
        VerificationEmailSentToAddress:
            "El correo electrónico de verificación se ha enviado al {0}.",
        VerificationTextMessage:
            "•Código. Utilice este código para la verificación de SunLoan.",
        "VerificationTextMessage.":
            "{CODE}. Utiliza este código para la verificación de Sun Loan.",
        VerificationTextSentToNumber:
            "El mensaje de texto de verificación se ha enviado al {0}.",
        VerifiedAt: "Verificada {0}",
        WelcomeToSunLoan: "Solicita un préstamo en linea de forma rápida, cómoda y con la tranquilidad de que ",
        WelcomeToSunLoanNoSoftHit: "Solicita un préstamo en línea de manera rápida y cómoda: Empieza ingresando tu información a continuación.",
        WelcomeToSunLoan2: "no afectará ",
        WelcomeToSunLoan3: "tu puntaje crediticio.* ",
        WelcomeClickNextMessage: "Haga clic en siguiente para enviar su solicitud y crear su cuenta my.sunloan.com. Esta dirección de correo electrónico será tu nombre de usuario. Es posible que recibas ",
        WelcomeClickNextMessage2: "una llamada o un mensaje de texto",
        WelcomeClickNextMessage3: " a este número de teléfono, con información importante acerca de tu solicitud o cuenta.",
        WelcomePurchasedLeadMessage: "Tu solicitud está casi completa. Sólo sigue los siguientes pasos, que te tomarán menos de 5 minutos.",
        WelcomePurchasedLeadItem1: "Registra tu cuenta en my.sunloan.com. Aquí podrás accesar y manejar tu cuenta en línea, las 24 horas del día, los 7 días de la semana.",
        WelcomePurchasedLeadItem2: "Elije la manera de recibir tus fondos: depósito bancario directo o en la sucursal.",
        WelcomePurchasedLeadItem3: "Verifica y envía tu solicitud.",
        WelcomePreApprovalOffer: "Ha sido preaprobado para hasta: ${0} *",
        WelcomePreApprovalOffer1: "Preaprobado pendiente de revisión de los documentos requeridos y suscripción adicional",
        WePutPersonal: "Para nosotros los préstamos personales a plazos son muy personales.",
        WePutPersonal2: "Financiamiento el mismo día. Servicio en línea y en más de 200 sucursales. Pagos mensuales asequibles.",
        WeStillNeedInformation: "Todavía necesitamos un poco más de información para procesar su solicitud. Llame al 1-800-SUN-LOAN (1-800-786-5626) para continuar.",
        WhatToExpectBusinessHours: "<p><b>Queremos agradecerle por elegir Sun Loan Company para ayudarle con sus necesidades.</b></p><p>Nos estamos comunicando con usted para confirmar que recibimos su aplicación el {0}. Uno de nuestros representantes de servicio al cliente lo llamará desde nuestro Centro de Servicio al Cliente de San Antonio, desde un número de teléfono con el código de área (210) en los próximos 30 minutos o menos para ingresar información adicional necesaria para completar el proceso.</p><p>Para acelerar el proceso, cree su cuenta my.sunloan.com a continuación, donde podrá subir documentos importantes. Su nombre de usuario es la dirección de correo electrónico que utilizó para su solicitud.</p><p>En caso de que pierda nuestra llamada o tenga alguna pregunta, no dude en contactarnos al:</p><p><b>(800) SUN-LOAN</b><br>(800-786-5626)</p>",
        WhatToExpectAfterBusinessHours: "<p><b>Queremos agradecerle por elegir Sun Loan Company para ayudarle con sus necesidades.</b></p><p>Nos estamos comunicando con usted para confirmar que recibimos su aplicación el {0}. Uno de nuestros representantes de servicio al cliente lo llamará desde nuestro Centro de Servicio al Cliente de San Antonio, desde un número de teléfono con el código de área (210) durante nuestro horario normal de oficina para ingresar información adicional necesaria para completar el proceso.</p><p>Para acelerar el proceso, cree su cuenta my.sunloan.com a continuación, donde podrá subir documentos importantes. Su nombre de usuario es la dirección de correo electrónico que utilizó para su solicitud.</p><p>En caso de que pierda nuestra llamada o tenga alguna pregunta, no dude en contactarnos al:</p><p><b>(800) SUN-LOAN</b><br>(800-786-5626)</p>",
        WhatToExpectGeneric: "<p><b>Gracias por elegir Sun Loan Company.</b></p><p>Espere una llamada (desde un código de área 210) durante el horario comercial normal, que es: de lunes a viernes de 8:00am - 7:00pm CT y sábados de 8:30am - 12:30pm CT.</p><p>Si necesita asistencia inmediata, comuníquese con nosotros al (800) SUN-LOAN durante el horario comercial.</p><p>Tenga en cuenta que puede administrar su cuenta en línea las 24 horas del día, los 7 días de la semana, los 365 días del año en my.sunloan.com</p>",
        WhatToExpectGenericExisting: "<p><b>Queremos agradecerle por elegir Sun Loan Company.</b></p><p>Esperamos la oportunidad de servirle.</p>",
        WillNotImpactCreditScore: "Solicitar un préstamo con Sun Loan no afectará su puntaje crediticio *",
        YourLoanApplicationHasBeenCompleted: "Su solicitud de préstamo se ha completado y sus fondos están listos.",
        YourLoanApplicationIsBeingProcessed: "Su solicitud de préstamo está en proceso. Le notificaremos con sus próximos pasos cuando se haya completado.",
        ZipCodeMaxCharactersReached: "El código postal no puede tener más de 9 digitos.",
    },
    Messages: {
        AccountNotAvailableFooter:
            "Please check back 48-72 hours after your loan has been approved or contact customer service if you believe that there is a problem with your account. ",
        AccountNotAvailableHeader:
            "Your account records are not available at this time. This could be because: ",
        AccountNotAvailableReason1: "Your loan has not been processed yet. ",
        AccountNotAvailableReason2:
            "There are errors or mismatched data in your account information. ",
        ACHpayment: "If set up, your ACH payment will go through even if  you make an online payment today, which may result in duplicate payments. If you have any questions please contact Customer Service at 1-800-SUN-LOAN",
        ACHNextInstallment: "ACH Payment Scheduled Date {0} for {1}",
        ACHPaymentFailed: "Your last ACH payment was unsuccessful. Please try again using a debit card.",
        AnUnexpectedErrorHasOcurred: "An unexpected error has occurred. Please retry your request.",
        AdditionalDocumentsAreRequired1: "Additional documents are required to continue processing your loan application. Go to ",
        AdditionalDocumentsAreRequired2: " to complete this step.",
        AllDocumentsSubmitted: "All Documents Have Been Submitted",
        ApplicationCompletedElectronic: "The amount you requested will be deposited within 24 hours.",
        ApplicationCompletedInPerson: "You can pickup your funds at your Sun Loan branch office:",
        ApplicationDeclined: "But you still have options.",
        ApplicationDeclined2: "We can connect you with a network of lenders who may be able to help. Click ",
        ApplicationDeclined3: " to find other options that may work for you.",
        ApplicationDeclinedOriginal: "You'll receive a letter soon with more details about our decision. While we couldn't approve your application, please keep in mind that this decision won't impact your credit score.*",
        ApplicationDeclined2Original: "If you have questions after you receive your letter, please don't hesitate to reach out. Thank you for applying with us today.",
        ApplicationProcessing: "Our team is working on your loan decision. This won’t take long – we’ll have an update for you shortly!​",
        ApplicationProcessing2: "Thank you for choosing us to ​help with your financial needs!",
        ApplicationInProcess: "Application in Process",
        ApplicationPreapproved: "You've been pre-qualified for up to ${0}",
        ApplicationPreapprovedCongratulations: "Congratulations, you've been pre-qualified for up to ${0}!",
        ArgumentRequiredOrIncorrectFormat: "The value is missing or incorrect.",
        AreYouSurePerformAction: "Are you sure you want perform the action?",
        AsShownOnID: "As shown on your driver's license, state ID, or passport",
        BankruptcyMessage:
            "Sun Loan has been notified that you are in the process of filing for bankruptcy or have done so.  As a result, your account has been suspended.  If you have any questions, please contact your branch or call customer service at {0}.",
        BorrowerMustBe18: "Borrowers must be 18 years of age.",
        ByCheckingThisBox: "By checking this box, I consent to be contacted, including to receive calls, text messages and prerecorded messages via automated technology, including autodialers, at the mobile or home number I provided, about products and services offered by or on behalf of Sun Loan. Messages and data rates may apply.",
        ByCheckingThisBox2: "SMS Terms of Use.",
        ByCheckingThisBox3: "My consent is not a condition of lending and will not affect whether Sun Loan lends to me.",
        CallOrText1: "We may",
        CallOrText2: "call you or text you",
        CallOrText3: "at this phone number with important information about your application or account",
        ChangeMyContactInformation: "Change my contact information",
        ChangeMyFinancialInformation: "Change my financial information",
        ChooseHowYouToReceiveFunds: "Choose how you would like to receive your funds",
        ChooseLoanOffice: "Receive funds remotely or in person.*",
        ChooseLoanOfficeDisclaimer: "*In order to fund your loan remotely, you must reside in the state where your branch is located.",
        CompleteRequiredFields: "Please complete the required fields",
        ConfirmEmail: "Email and confirm email should be same",
        ConfirmPassword: "Confirm Password",
        ConfirmRefinanceIncrease:
            "Please call or come by to complete the loan process. Otherwise, someone will be in touch with you soon to help you complete  your loan.",
        ConfirmRemoveSavedPaymentMethod: "Are you sure you want to remove this saved payment method?",
        ContactCustomerSupport:
            "For questions about your loan or the status of a loan request, please contact Customer Support at:",
        ContactInformationOnFile: "the contact information on file",
        ContactLocalBranch:
            "For questions about your loan or the status of a loan request, contact your local branch:",
        Continue: "Continue",
        CouldNotCompleteOperation: "Could not complete the operation.",
        CouldNotCreateAccount:
            "We could not create your account at this time. Please try again or contact customer service for assistance.",
        ConfirmAccountNumber: "Account number and confirmed account number should be the same.",
        ConfirmRoutingNumber: "Routing number and confirmed routing number should be the same.",
        Copyright: "© Copyright {0} Sun Loan Company. All rights reserved.",
        DeleteSavedPaymentFailed:
            "One or more of the saved payment methods could not be deleted. The list of payments has been refreshed.",
        DeviceRegistrationRequired:
            "Your current device needs to be validated and registered.",
        DidntGetCode: "Didn't get a code?",
        DocumentLink1Message: "Please go to ",
        DocumentLink2Message: "for the next steps",
        DocumentLink: "My Documents ",
        DocumentName: "Document name: {0}",
        DocumentsNotFound: "No Documents Found.",
        DocumentProofSubmitted: "Your {0} Has Been Submitted.",
        DocumentOptionsText: "You have a few easy options to submit your documents to continue your application",
        DocumentRejected: "Document Notification!",
        DocumentsAccepted: "{0} of {1} documents accepted",
        DocumentsUploaded: "{0} of {1} documents uploaded",
        DocumentUploadSuccessful: "The Document Upload was sucessful.",
        DocumentSecureUpload: '<p class="mb-0 pb-0">Please Upload required document </p><p class="mt-0 pt-0">Documents may take up to a minute to upload</p>',
        DocumentSecureUploadDocument: "Document Accepted",
        DocumentSecureUploadDocuments: "Documents Accepted",
        DocumentStatus: "Status: {0}",
        DocSunLoanEmail: "upload@sunloan.com",
        DocSunLoanPhone: "1-726-201-0818",
        ElectronicDelivery: "We will collect your debit card information during the verification phone call.",
        EmailHasIncorrectFormat: "The email is not in correct format",
        EmailInUsePleaseLogin: "Email in use, please login.",
        ExpediteTheDocument: "To expedite the document review process, please send texts and emails from the phone number or email that listed on your application",
        ExistingCustomerRegistrationIdentity1: "Please enter your SSN or ITIN and DOB below to register your my.sunloan.com account.",
        ExistingCustomerRegistrationIdentity2: "<p>To verify your account we will send an authentication code to the email on file at Sun Loan.</p><p>If you no longer have access to the email on file, please update it by visiting your local branch or by calling 1-800-Sun-Loan.</p>",
        ExistingEmailValidation: "If the date of birth and SSN are found, we will send a confirmation code to the email on file with Sun Loan. If you no longer have access to the email on file, please stop by your local branch or call 1-800-Sun-Loan.",
        ReCaptchaFailed: "reCAPTCHA failed for your session.",
        Error404NotFound: "Error 404: Not Found",
        ErrorCannotFindLoan: 'We are having trouble finding your loan.To make a payment, please <a href="https://my.sunloan.com/">login</a> or <a href="https://my.sunloan.com/SignUpCustomerStatus">sign up</a>.',
        ErrorInvalidLeadToken: "Please call 1-844-Sun-Loan for assistance.",
        Error_PaymentIsPending:
            "Cannot make a payment on a loan while another payment is pending.",
        ErrorUploadingDocument: "Error uploading document",
        Find_Office:
            "First, let's find a loan office near you to handle your loan.",
        FileSizeErrorTitle: "Oops, File size exceeds the 10mb limit.",
        FileTypeErrorTitle: "Oops, unsupported file type.",
        FilesAllowedErrorTitle: "Oops, the number of files exceeds the limit allowed.",
        FilesAllowedErrorText: "Please try with less files.",
        FileSizeErrorText: "Please try a different file.",
        FileTypeErrorText: "We do not support that file type.",
        FooterLenderComplaint: '<p>TO REPORT A PROBLEM OR COMPLAINT WITH THIS LENDER, YOU MAY WRITE OR CALL: Compliance Department, 1020 NE Loop 410, Ste 380, San Antonio TX 78209, <a href="tel:8005317652">800-531-7652</a>, <a href="mailto:contact@sunloan.com">contact@sunloan.com</a></p>',
        ForgoPasswordSendTo: "We can send an email or a text to your mobile phone.",
        ForgotPassword:
            "To recover your password, we will need to send a password reset code.",
        ForgotPasswordChanged:
            "Your password has been changed. Please return to the login screen to log in with your new password. ",
        ForgotPasswordMfaSentMessage:
            "If the information  you entered matches our records, a code will be sent to you. Please enter the code here to confirm your identity and reset your password. If you do not receive a code, please contact customer support for further assistance.",
        ForgotPasswordWrongAnswerSubtitle1:
            "We’re sorry, but the answers you provided don’t match the info we have on file for this account. We’re sorry, but the answers you provided don’t match the info we have on file for this account. You can try again or contact us for help.",
        ForgotPasswordWrongAnswerSubtitle2:
            "You have {0} more tries before your account is locked for safety.",
        FormValid: "Correct the errors and submit the form again",
        ForTheInitialPurpose: '* For the initial purposes of pre-qualifying you for a loan, we will use credit information from one or more Credit Reporting Agencies. This information is pulled using a "soft" credit inquiry, which does not impact your credit score. If you are approved for and accept the loan, we will obtain a complete Consumer Credit Report from one or more Credit Reporting Agencies; this request for a credit report will result in a "hard" credit inquiry and may impact your credit score',
        GoodNews: "A lender is ready to work with you. Click ",
        GoodNews2: " to connect with them.",
        SuspendedFlagMessage:
            "Your account has been suspended. If you have any questions, please contact your branch or call customer service at {0}.",
        IdMissing:
            "Identification Needed!",
        IdFront:
            "Photo of Identity Front ",
        IdBack:
            "Photo of Identity Back",
        InOffice: "One of our branches may be able to assist in person.",
        IfYouHaveAnyQuestions: "If you have any questions regarding your application status please call 1-800-SUN-LOAN (1-800-786-5626) and we will be able to assist you.",
        includesSchedule: "(This includes your scheduled monthly payment and fees)",
        IncreaseLoanText:
            "This will increase this original amount of your loan. You will be paid the difference and your monthly payment will increase.*",
        IncreaseRefinanceDisclaimer: "* Subject to policy and credit approval.",
        InstantFunding:
            "Enter your debit card information below for loan funding after a loan approval and acceptance. There will be no charges associated with this transaction. Credit cards cannot be funded.",
        InvalidAuthenticationCode:
            "The code that was supplied could not be validated. ",
        InvalidFormat: "Invalid format",
        InvalidSSN: "Invalid Social Security Number.",
        InvalidITINLength: "Invalid Individual Tax Identification Number (ITIN) must be 9 digits.",
        ITINError: "Invalid Individual Tax Identification Number (ITIN).",
        LPXAppInProcess: "<p><strong>Expect a Call From Us</strong></p><p>You may receive a call from our Loan Specialists at our Service Center in San Antonio, TX, or from your local branch.</p><p><strong>Be Ready to Provide Additional Information</strong></p><p>You may need to provide additional information such as: Proof of income and ID.  You can do this by emailing those documents to <a href='mailto:docs@sunloanonline.com'>docs@sunloanonline.com</a>, texting them to 1-726-201-0818 or uploading them on the <a href='/my-documents'>My Documents</a> Page.</p><p><strong>Get Your Funds</strong></p><p>Get funded as quickly as today! During our normal business hours, we are able to fund as quickly as the same day you apply.</p>",
        LoanInstructions:
            "This online form is not a complete loan application and is just for the purpose of collecting preliminary contact information. Our office staff will contact you within 24 hours (except on weekends and holidays) to complete the application process. You must complete our application with the branch (phone or in person) and the loan must be closed in the branch in person.",
        LoanSentTo: "Your Loan Application has been sent to:",
        LoanNumber: `Loan Number: {0}`,
        LocateWithin: "Locate Sun loan offices within:",
        LoginFailed:
            "The login failed; the information provided could not be validated. Your account will be locked after 3 failed attempts.",
        Maintenance: "Our engineers are currently performing scheduled maintenance. We'll be back soon. Sorry for any inconvenience",
        MessageBodyNotSupplied: "Email body or template id is required. ",
        MfaCodeFailed:
            "Could not validate the code supplied. Please check the code and try again. ",
        MfaConfirmSent: "For your security, we need to verify your identity.",
        MfaEnterConfirmInfo:
            "To verify your identity, please enter the confirmation code below.",
        MfaWillConfirmEmail:
            "For your security, we need to verify your identity and will send a verification code to the email address on file. Click next continue.",
        MfaWillConfirmPhone:
            "For your security, we need to verify your identity and will send a verification code to the phone. Click next continue.",
        MobileOptIn:
            "We need to confirm your mobile number and will send a verification code to your new mobile number. Click next to continue. ",
        MobilePhoneError: "Please enter a valid 10 digit phone number containing only numbers and that doesn’t start with a 0 or 1.",
        MoreInformation: "To determine if another lender can offer you a loan, please provide a few more details. Your information is securely encrypted and will only be used for this application.* ",
        MoreInformationDisclaimer: "*Sun Loan Company does not store this information",
        NewCustomers: "*New customers applying for loans over $1800 must pick up funds in branch.",
        NoBusinessInState: "Unfortunately, we don't offer a product in your state.",
        NoContractsFound: "No Contract Documents Found",
        NoACHNoticesFound: "No ACH Notice Documents Found",
        NoBranchNearYou: "Sorry, we don't have any branches within 50 miles of your location.",
        NoLiveCheckVoidLettersFound: "No Live Check Void Letter Documents Found",
        NoLegalsFound: "No Legal Documents Found",
        NoLettersFound: "No Letter Documents Found",
        noIdsFound: "No Id Documents Found",
        NoLocationFound:
            "Unfortunately, we do not have a Sun Loan location within {0} miles of zip code {1}. We currently have offices in Alabama, Illinois, Missouri, Nevada, New Mexico, Oklahoma and Texas. Please change your search criteria to find an office near you.",
        NoOffers: "After reviewing the information provided, the network of lenders wasn't able to extend a loan officer. We appreciate you giving this option a try.",
        NumericValue: "Only numbers are allowed",
        NotPayoffAmount:
            "This is not your loan early payoff amount. If you want to pay off this loan early, call {0}.",
        OneOfOurRepresentatives: "One of our representatives will be calling you from our Customer Service Center in San Antonio, TX using a phone # with a 210 area code OR from a local branch as soon as possible. This call may include a request for additional information necessary to complete the process.",
        OtherQuestions: "For all other questions, call Customer Support at: ",
        OtherAmount: `Please note that {0} is less than the amount owed of {1}`,
        Or: "Or",
        PasswordDisplayLengthError:
            "The {0} must be at least {2} and at max {1} characters long.",
        PasswordRequirements:
            "Passwords must be at least 8 characters long and include at least one number (1, 2, 3, etc), one capital letter (R, T ,N, etc) and one special character (&, %, !, etc).",
        PasswordsDoNotMatch: "Confirm password does not match the password",
        PaymentDeclined: "Your last payment was declined.",
        PaymentInProcess: "You have a payment in process.",
        PaymentPastDue: "Payment is Past Due",
        PayoffAtBranch:
            "The payoff amount for your loan as of {0} was ${1}.  Please pay no more than that amount and call your branch at {2} or {3} with any questions.",
        PayoffAtCustomerService:
            "The payoff amount for your loan as of {0} is ${1}.  Please pay no more than that amount and call your branch or {2} with any questions.",
        PayByBankHeader: "Pay By Bank Account",
        PayByBank: "Make a payment using your bank account. There is no charge for this service.",
        PayByCardHeader: "Pay By Debit Card",
        PayByCard: "Make a payment using your debit card. A ${0} payment processor fee will be charged at the time of payment. Sun Loan does not receive any portion of this fee.",
        PayByCardNoFee: "Make a payment using your debit card.",
        PaymentSuccessNewAccount: "Create an account today!",
        PaymentSuccessExistingAccount: "Login to your account today!",
        PaymentSuccessNewAccount1: "24/7 account access",
        PaymentSuccessNewAccount2: "Make a payment",
        PaymentSuccessNewAccount3: "Request a refinance or loan increase",
        PaymentSuccessNewAccount4: "Check your account balance",
        PaymentSuccessNewAccount5: "& more!",
        PleaseCompleteReferralBeforeAdding:
            "Please complete entering your current referral before adding a new one.",
        PleaseCompleteSteps: "To continue processing your application, please upload the following documents:",
        PleaseCompleteSteps1: "An unexpired government-issued, picture ID.",
        PleaseCompleteSteps2: "A current pay stub or other proof of income.",
        PleaseCompleteSteps3: "Two recent bills showing your address.",
        PleaseProvideUsWithMoreInformation:
            "Please provide us with some more information to confirm your identity.",
        PleaseSubmitNewDocument: "Please submit a new document",
        PreApprovalCodeInvalid: "Sorry! We can't verify the information you entered.",
        ProfileChangesSubmitted:
            "Your profile have been successfully posted for processing. It may take a few minutes for the changes to be reflected in your account.",
        ProofOfIdentity: "Please upload the front of your state or government issued ID",
        ProofOfResidence:
            "Please upload two different bills or other item with your address",
        ProofOfIncome:
            "Please upload your current paystub and other proof of income",
        PostalCodeError: "Please enter a valid 5 digit postal code.",
        ReferAFriendPara1:
            "Get a chance to make up to $100* when you refer a friend, co-worker, or family members.",
        ReferAFriendPara2:
            "Type their name and email below and we'll them send an invitation to apply on your behalf. It's that simple!",
        ReferAFriendPara3:
            "The best part is there's no limit on how many people you can refer to us!",
        ReferralMessage1:
            "A friend you referred has signed up with us! Please come in to your Sun Loan branch office to collect your referral reward.",
        ReferAFriendDisclaimer:
            "* Subject to loan being made. Contact your branch for details.",
        ReferralMessage2: "Thanks for the referral!",
        ReferralsEarned: "You have earned a referral fee!",
        ReferralSubmittedPara1: "Thank you for your referral.",
        ReferralSubmittedPara2:
            "Please be sure to let your friends or family members know about your referral and ask them to share your name with us when they apply for a loan.",
        ReferralSubmittedPara3:
            "We'll be sending an email on your behalf. Once we hear back, we will be contacting you!",
        RefinanceLoanText:
            "This will reset your loan amount and loan term to the original amount. You will be paid the difference.*",
        RequestedAmountInvalid: "Requested amount is not valid.",
        RequestedAmountMin: "Please enter a requested amount greater than ${1}.",
        RequestedAmountMax: "Please enter a requested amount less than ${1}.",
        RequiredField: "Cannot be blank",
        RequiredFieldNotSupplied: "A value is required for {0}.",
        SocialSecurityDoesNotMatch: "Please make sure the numbers match.",
        TaxIdentificationDoesNotMatch: "Please make sure the numbers match.",
        ResetPasswordFailed:
            "We could not reset your password at this time. Either your account information or the security code that you supplied was incorrect. Please try again or contact customer service. ",
        ReviewFollowingSections: "* Please review and complete the following sections in order to submit:",
        SessionTimeout:
            "Your session is about to timout due to inactivity. Click Continue to continue your session.",
        SuccessOperation: "The operation was completed sucessfully.",
        TakePicture: "Text a picture of your document to 1-726-201-0818.  *Text one picture at a time; then wait for a confirmation before submitting the next document",
        TakePictureProofs: "Take a picture of your current drivers license, two recent bills with your address, a current paystub and other proof of employment and email or upload the picture using the form below",
        TakePictureProofsWithTexting: "Take a picture of your current drivers license, two recent bills with your address, a current paystub and other proof of employment and email, text or upload the picture using the form below",
        TextMessageNumberIncorrectFormat:
            "The target text messaging number should be +1 followed by the 10 digit number.",
        ThankYou: "Thank You!",
        ThankYouDocsSubmitted: "Thank you, all documents have been submitted.",
        ThankYouDocsSubmittedReviewed: "Thank you, all documents have been submitted and are being reviewed.",
        ThirdParty: "Our records indicate your account has charged off and has been turned over to {0} to collect. Please call {0} at <a href='tel:{1}'>{2}</a> Monday - Thursday: {3} to {4}, Friday: {5} to {6} to arrange payment. Or visit <a href='{7}'>{7}</a> to make a payment.",
        ThisEmail: 'This email address will be your account username. We will also use it to',
        ThisEmail2: 'contact you',
        UploadPictureTo: "Email your documents to",
        UnableToCompleteRequest: "Unfortunately we are unable to complete your request at this time.",
        UnfortunatelyUnableToProcess1: "Unfortunately we are not able to approve your application at this time. Please go to ",
        UnfortunatelyUnableToProcess2: " for more details.",
        UnfortunatelyUnableToProcess90Days: "Unfortunately we are not able to approve your application at this time.  We will send you a letter with more information within 90 days.",
        UnregisteredDevice:
            "This device is not registered to your account. For your security, we must register your device by sending an authentication code to {0}.",
        UserHashMatchFound: "It looks like you already have an account with sunloan.com.Please sign in below to submit your application.",
        UploadFiles: "Upload Files",
        UploadUsingForms: "Upload your documents below",
        UpdatedAt: "Updated at: {0}",
        VerificationEmailSentToAddress:
            "The verification email has been sent to {0}.",
        VerificationTextMessage: "{CODE}. Use this code for SunLoan verification.",
        "VerificationTextMessage.":
            "{CODE}. Use this code for SunLoan verification.",
        VerificationTextSentToNumber:
            "The verification text message has been sent to {0}.",
        VerifiedAt: "Verified {0}",
        WelcomeToSunLoan: "Apply for a loan online quickly and conveniently.  Get started below with ",
        WelcomeToSunLoanNoSoftHit: "Apply for a loan online quickly and conveniently - get started by entering your information below.",
        WelcomeToSunLoan2: "no impact ",
        WelcomeToSunLoan3: "to your credit score when you apply.* ",
        WelcomeClickNextMessage: "Click next to submit your application and to create your my.sunloan.com account. Your email address will be your account username. We may ",
        WelcomeClickNextMessage2: "call you or text you",
        WelcomeClickNextMessage3: " on your mobile number with important information about your application or account.",
        WelcomePurchasedLeadMessage: "Your application is nearly complete!  The next steps should take less than 5 minutes:",
        WelcomePurchasedLeadItem1: "Create your my.sunloan.com account - you will be able to manage your loan online 24/7 from this account!",
        WelcomePurchasedLeadItem2: "Select your funding method - Instant Funding or In Branch!",
        WelcomePurchasedLeadItem3: "Verify and submit your application.",
        WelcomePreApprovalOffer: "You have been pre-approved for up to: ${0} *",
        WelcomePreApprovalOffer1: "* Pre-approved pending review of required documents and additional underwriting",
        WePutPersonal: "We put personal back in personal installment loans",
        WePutPersonal2: "Same day funding. Online and in-branch service with 200+ locations. Affordable monthly payments.",
        WeStillNeedInformation: "We still need a bit more information to process your application. Please call 1-800-SUN-LOAN (1-800-786-5626) to continue.",
        WhatToExpectBusinessHours: "<p><b>We want to thank you for choosing Sun Loan Company to meet your needs and look forward to the opportunity to serve you!</b></p><p>This is to confirm that your information was submitted successfully on {0}. One of our customer service representatives will be calling you from our San Antonio Customer Service Center, from a phone number with area code (210) in the next 30-mins or less to gather additional information necessary to complete the process.</p><p>To speed up the process, create your my.sunloan.com account below where you will be able to upload important documents. Your username is the email address you used for your application.</p><p>In case you miss our call or have any questions, please feel free to contact us at:</p><p><b>(800) SUN-LOAN</b><br>(800-786-5626)</p>",
        WhatToExpectAfterBusinessHours: "<p><b>We want to thank you for choosing Sun Loan Company to meet your needs and look forward to the opportunity to serve you!</b></p><p>This is to confirm that your information was submitted successfully on {0}. One of our customer service representatives will be calling you from our San Antonio Customer Service Center, from a phone number with area code (210) during normal business hours to gather additional information necessary to complete the process.</p><p>To speed up the process, create your my.sunloan.com account below where you will be able to upload important documents. Your username is the email address you used for your application.</p><p>In case you miss our call or have any questions, please feel free to contact us at:</p><p><b>(800) SUN-LOAN</b><br>(800-786-5626)</p>",
        WhatToExpectGeneric: "<p><b>Thank you for choosing Sun Loan Company.</b></p><p>Expect a call (from a 210 area code) during normal business hours which are:</br>Monday - Friday 8:00am-7:00pm CT and Saturday 8:30am-12-30pm CT.</p><p>If you need immediate assistance, reach us at (800) SUN-LOAN during business hours.</p><p>Please know that you can manage your account online 24/7/365 on my.sunloan.com</p>",
        WhatToExpectGenericExisting: "<p><b>Thank you for choosing Sun Loan Company.</b></p></p>We look forward to the opportunity to serve you.</p>",
        WillNotImpactCreditScore: "Applying for a loan with Sun Loan will not impact your credit score *",
        YourLoanApplicationHasBeenCompleted: "Your loan application has been completed and your funds are ready.",
        YourLoanApplicationIsBeingProcessed: "Your loan application is being processed. We will notify you with your next steps when it has been completed.",
    },
    "PageTitles.es": {
        AccountActivity: "Actividad de la cuenta",
        AccountConfirmation: "Confirmar cuenta",
        AccountHistory: "Historial de cuentas",
        AccountSuspended: "Cuenta suspendida",
        ApplicationRequests: "Solicitudes de aplicación",
        ApplicationReceived: "Aplicación Recibida!",
        ApplicationDeclined: "Su Solicitud No Fue Aprobada - Pero Aún Tiene Opciones",
        ApplicationProcessing: "Un Momento. Estamos revisando tu solicitud",
        BankingInfo: "Información bancaria",
        BankAccountType: "Tipo de cuenta bancaria",
        BiometricsScreenTitle:
            "¿Desea configurar el reconocimiento de rostros o huellas dactilares en su dispositivo?",
        BorrowAmount: "¿Cuánto te gustaría pedir prestado?",
        CallUs: "Llámenos",
        ConfirmationSummary: "Revisa y confirma tu información",
        ChangeMyInfo: "Cambiar mi información",
        CustomerService: "Servicio al cliente",
        ConfirmationApplicationReceived: "Recibimos tu solicitud y tus preferencias de cuenta. Ahora estamos revisando la información.",
        ContactInformation: "Información del contacto",
        DoYouRentOrOwn: "¿Renta o es dueño?",
        DocumentSecureUpload: "Carga Segura",
        EmailConfirmation: "Confirmación por correo electrónico",
        EmailValidation:
            "Para confirmar tu registro, hemos enviado un correo electrónico a:",
        EmployerContactInformation: "Información de contacto del empleador",
        Employment: "Empleo",
        EmployerInformation: "Información del empleador",
        Find_Office: "Buscar mi oficina de préstamos",
        ForgotPassword: "Olvidé mi contraseña",
        ForgotPasswordIdentityLabel:
            "Proporciona la siguiente información para continuar.",
        ForgotPasswordSubTitle:
            "Para recuperar su contraseña, necesitaremos enviar un código de restablecimiento de contraseña.",
        ForgotPasswordSubTitle1:
            "Podemos enviar un correo electrónico o un mensaje de texto a su teléfono móvil.",
        ForgotPasswordWrongAnswersSubTitle: "Respuestas de seguridad",
        Funding: "¿Cómo quieres recibir tus fondos?",
        GetStartedAndApplyTodayTitle: "¡Para empezar, aplique aquí!",
        GoodNews: "¡Albricias!",
        SuspendedFlag: "Cuenta Suspendida",
        Identification: "Identificación",
        IdentityLabel:
            "Proporciona tu número de identificación y fecha de nacimiento.",
        IDInfo: "Información de identificación",
        Income: "Ingresos",
        IncreaseRefinance: "Aumentar/Refinanciar su préstamo",
        LanguagePrefrence: "Establecer preferencia de idioma",
        LetsGetYouStarted: "¡Comencemos con tu aplicación!",
        LetsVerifyYourPreApprovalInformation: "Verifiquemos su información previa a la aprobación",
        LoanApplication: "Solicitud de Préstamo",
        LocateOfficesWithin: "Localice las Oficinas de Préstamos Sun dentro de",
        MakePayment: "Hacer un pago",
        My_Info: "Mi información",
        MyAccount: "Mis Préstamos",
        MyAccountHistory: "Mi Cuenta",
        MyDocuments: "Mis Documentos",
        MyInfo: "Por favor, proporciona tu información",
        MyIncome: "Mi Ingreso",
        MyPassword: "My Contraseña",
        MyProfile: "Mi perfil",
        MobileConfirmation: "Confirmación por celular",
        MoreInformation: "Necesitamos Más Información",
        NewLoan: "Préstamo nuevo",
        Notice: "Aviso",
        NoOffers: "No hay ofertas disponibles en este momento.",
        NumberOfYearsMonthsEmployed: "Cuánto tiempo has trabajado aquí",
        NumberOfYearsMonthsInHome: "¿Cuánto tiempo has vivido en esta dirección?",
        Password: "Contraseña",
        Password_Label: "Por favor crea una contraseña para tu cuenta y haga clic en siguiente para continuar.",
        PasswordPreapproved_Label: "Crea una cuenta para cargar los documentos necesarios y completar el proceso de tu solicitud.",
        PaymentSchedule: "Fechas de pagos",
        PaymentSuccess: "¡Gracias! Su pago fue exitoso.",
        PhoneNotificationLabel:
            "¿Deseas que te enviemos notificaciones por texto a tu teléfono celular?",
        PleaseConfirm: "Por favor, confirma tu solicitud",
        PleaseBeAccurateAsPossible: "Sea lo más preciso posible",
        PleadAddSourceIncome: "Indica a continuación, tu fuente de ingresos. Por ejemplo: empleo de tiempo completo, Seguro Social, manutención de los hijos, etc. Puedes agregar multiples fuentes de ingresos si tienes más de uno.",
        PreApprovalAmount: "Cantidad preaprobada",
        PrivatePolicy: "Política de privacidad",
        ProfileChanged: "Cambios de perfil enviados",
        ProofOfIdentity: "Prueba de Identidad",
        ProofOfResidence: "Prueba de Residencia",
        ProofOfIncome: "Prueba de Ingresos",
        ReferFriend: "Referir a un amigo",
        Request_Increase: "Solicita un aumento en tu préstamo",
        Request_New: "Solicitar un préstamo nuevo",
        RequestedAmount: "Importe solicitado",
        RequestSent: "Solicitud enviada",
        SectionChangePassword: "Cambiar contraseña",
        SectionMyInfo: "Mi información",
        SecurityOptions: "Opciones de seguridad",
        SecurityScreenPara: "¿Cómo le gustaría recibir mensajes de confirmación?",
        SecurityScreenPara1: "Reconocimiento de rostros y huellas dactilares",
        SelectedLoan: "Mi Préstamo Actual",
        SelectLoan: "Selecciona Préstamo",
        SelectPayment: "Selecciona Pago",
        SelectYourIdentificationType: "Seleccione su tipo de identificación",
        SessionExpiration: "Tiempo de Sesión Agotado",
        SendMessage: "o Enviarnos un mensaje",
        SetPassword: "Ingresar contraseña",

        SignIn: "Inicia sesión",
        SignupLoginScreenTitle:
            "Gracias por inscribirse en Sun Loan. Inicia sesión para completar tu registro y ver tu nueva cuenta.",
        SignUpMain: "Regístrate",
        SignUpMainLabel: "¿Alguna vez has tenido un préstamo con Sun Loan?",
        SignUpSection:
            "¿Postulando por primera vez?",
        SignUpSectionBottom: "¿Necesito una cuenta?",
        TextConfirmation: "Confirmación de texto",
        ToMakeAPayment: "Para realizar un pago sin crear una cuenta, ingrese su información a continuación.",
        VerifyApplication: "Verifica tu aplicación",
        WelcomeBack: "Bienvenido de nuevo!",
        WelcomeToSunLoan: "¡Bienvenido(a) a Sun Loan!",
        WhereDoYouLive: "¿Donde vives?",
        WhoIsYourEmployer: "Quien es tu empleador?",
        YourApplicationHasBeenSubmitted: "Your application has been submitted!",
        YourFinances: "Cuéntanos sobre tu trabajo e ingresos",
        YourInformation: "Repasemos su información personal",
    },
    PageTitles: {
        AccountActivity: "Payment History",
        AccountConfirmation: "Account Confirmation",
        AccountHistory: "Account History",
        AccountSuspended: "Account Suspended",
        ApplicationRequests: "Application Requests",
        ApplicationReceived: "Application Received!",
        ApplicationDeclined: "Your Application Wasn’t Approved – But You Still Have Options",
        ApplicationProcessing: "Hang Tight: ​We’re Reviewing Your Application",
        BankingInfo: "Banking Info",
        BiometricsScreenTitle:
            "Would you like to set up face or fingerprint recognition on your device?",
        BorrowAmount: "How much would you like to borrow?",
        CallUs: "Call Us",
        ChangeMyInfo: "Change My Info",
        ConfirmationApplicationReceived: "Your application and account preferences have been received and are now being reviewed.",
        ConfirmationSummary: "Review and Confirm Your Information",
        CustomerService: "Customer Service",
        ContactInformation: "Contact Information",
        DocumentSecureUpload: "Secure Upload",
        DoYouRentOrOwn: "Do you rent or do you own?",
        EmailConfirmation: "Email Confirmation",
        EmailValidation: "To confirm your registration, we have sent an email to:",
        EmployerContactInformation: "Employer contact information",
        Employment: "Employment",
        EmployerInformation: "Employer Information",
        Find_Office: "Find My Loan Office",
        ForgotPassword: "Forgot My Password",
        ForgotPasswordIdentityLabel:
            "Please provide the following information to continue.",
        ForgotPasswordSubTitle:
            "To recover your password, we will need to send a password reset code.",
        ForgotPasswordSubTitle1:
            "We can send an email or a text to your mobile phone.",
        ForgotPasswordWrongAnswersSubTitle: "Security Answers",
        Funding: "If approved, how would you like to receive your funds?",
        GetStartedAndApplyTodayTitle: "Get Started and Apply Today!",
        GoodNews: "Good News!",
        SuspendedFlag: "Account Suspended",
        IdentityLabel:
            "Please provide your identification number and date of birth.",
        Identification: "Identification",
        IDInfo: "ID Info",
        Income: "Income",
        IncreaseRefinance: "Increase/Refinance Your Loan",
        LanguagePrefrence: "Set Language Preference",
        LetsGetYouStarted: "Let's get started with your application!",
        LetsVerifyYourPreApprovalInformation: "Let's verify your pre-approval information",
        LoanApplication: "Loan Application",
        LocateOfficesWithin: "Locate Sun Loan Offices within",
        MakeAPaymentTitle1: "How much would you like to pay?",
        MakePayment: "Make a Payment",
        My_Info: "My Information",
        MyAccount: "My Loans",
        MyAccountHistory: "My Account",
        MyDocuments: "My Documents",
        MyInfo: "Please Enter your information",
        MyPassword: "My Password",
        MyProfile: "My Profile",
        MyIncome: "My Income",
        MobileConfirmation: "Mobile Confirmation",
        MoreInformation: "More Information Needed",
        NewLoan: "New Loan",
        Notice: "Notice",
        NoOffers: "No offers available at this time",
        NumberOfYearsMonthsEmployed: "How long have you worked here?",
        NumberOfYearsMonthsInHome: "How long have you lived at this address?",
        Password: "Password",
        Password_Label: "Please create a password for your account, and click next to continue.",
        PasswordPreapproved_Label: "Create an account to upload the documents needed to finish processing your application.",
        PaymentSchedule: "Payment Schedule",
        PaymentSuccess: "Thank you! Your payment was successful.",
        PhoneNotificationLabel:
            "Would you like for us to send text notifications to your mobile phone?",
        PleaseConfirm: "Please confirm your application",
        PleaseBeAccurateAsPossible: "Please be as accurate as possible",
        PleadAddSourceIncome: "Below, please add your job or other source of income. (For example: Full Time Employment, Social Security, Child Support, etc.) You can add multiple jobs/sources of income if you have more than one.",
        PreApprovalAmount: "Pre-Approved Amount",
        PrivatePolicy: "Privacy Policy",
        ProfileChanged: "Profile Changes Submitted",
        ProofOfIdentity: "Proof of Identity",
        ProofOfResidence: "Proof of Residence",
        ProofOfIncome: "Proof of Income",
        ReferFriend: "Refer a Friend",
        ReferralUpdate: "Referral",
        Request_Increase: "Request an Increase on Your Loan",
        Request_New: "Request a New Loan",
        RequestedAmount: "Requested Amount",
        RequestSent: "Request Sent",
        SectionChangePassword: "Change Password",
        SectionMyInfo: "My Information",
        SecurityOptions: "Security Options",
        SecurityScreenPara: "How would you like to receive confirmation messages?",
        SecurityScreenPara1: "Face and Fingerprint Recognition",
        SelectedLoan: "My Current Loan",
        SelectLoan: "Select Loan",
        SelectPayment: "Select Payment",
        SelectYourIdentificationType: "Select your identification type",
        SendMessage: "or Send Us a Message",
        SessionExpiration: "Session Timeout",
        SetPassword: "Set Password",
        SignIn: "Sign In",
        SignupLoginScreenTitle:
            "Thank you for signing up with Sun Loan. Sign in to complete your registration and view your new account.",
        SignUpMain: "Sign Up",
        SignUpMainLabel: "Have you ever had a loan with Sun Loan?",
        SignUpSection:
            "Applying for the first time?",
        SignUpSectionBottom: "Need an account?",
        TextConfirmation: "Text Confirmation",
        ToMakeAPayment: "To make a payment without creating an account, please enter your information below.",
        VerifyApplication: "Verify Your Application",
        WelcomeBack: "Welcome Back!",
        WelcomeToSunLoan: "Welcome to Sun Loan!",
        WhereDoYouLive: "Where do you live?",
        WhoIsYourEmployer: "Who is your employer?",
        YourApplicationHasBeenSubmitted: "Your application has been submitted!",
        YourFinances: "Tell us about your job and income",
        YourInformation: "Let's go over your personal information",
    },
    "PlaceHolder.es": {
        IncomePerPeriod: "$",
        IncreaseAmount: "$",
        RequestedAmount: "$"
    },
    PlaceHolder: {
        IncomePerPeriod: "$",
        IncreaseAmount: "$",
        RequestedAmount: "$"
    },
    "MyDocuments.es": {
        noContractsFound: "No Contract Documents Found",
        noLettersFound: "No Letter Documents Found",
        noIdsFound: "No Id Documents Found"
    },
    MyDocuments: {
        noContractsFound: "No Contract Documents Found",
        noLettersFound: "No Letter Documents Found",
        noIdsFound: "No Id Documents Found"
    }
};
